
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fWGpT", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $5d9b4 = parcelRequire("5d9b4");


var $hvdlr = parcelRequire("hvdlr");


var $1iSzD = parcelRequire("1iSzD");


var $04e9M = parcelRequire("04e9M");


var $6mKj3 = parcelRequire("6mKj3");


var $9137z = parcelRequire("9137z");


var $j8hiR = parcelRequire("j8hiR");


var $1VB1N = parcelRequire("1VB1N");


var $8VXwD = parcelRequire("8VXwD");


var $bNHtR = parcelRequire("bNHtR");


var $gNjy8 = parcelRequire("gNjy8");

const $6e4f6ea8730b931f$export$1504d130127dbc5f = (options)=>{
    const cloudId = options?.cloudId ?? '';
    const contentId = options?.contentId ?? '';
    const contentType = options?.contentType ?? '';
    const fetchUsersClient = options?.fetchUsersClient ?? '';
    return `${cloudId}_${contentId}_${contentType}_${fetchUsersClient}`;
};
const $6e4f6ea8730b931f$export$3c298c8b4091db27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((options)=>{
    // start measuring duration for initializing the provider
    (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_INIT);
    (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH);
    const { contentId: contentId, cloudId: cloudId, activationId: activationId, contentType: contentType, permissionTokenRefresh: permissionTokenRefresh, initialDraft: initialDraft, isLivePage: isLivePage, onUserFetchError: onUserFetchError, presenceId: presenceId, presenceActivity: presenceActivity, userId: userId, fetchUsersClient: fetchUsersClient } = options;
    const url = (0, $1VB1N.getCollabProviderUrl)();
    const path = (0, $6mKj3.expVal)('platform_editor_to_use_pmr_for_collab_edit_none_ic', 'isEnabled', false) ? (0, $1VB1N.getCollabEditServicePath)(cloudId, activationId) : undefined;
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const product = isEmbeddedConfluence ? 'embeddedConfluence' : 'confluence';
    const documentAri = `ari:cloud:confluence:${cloudId}:${contentType}/${contentId}`;
    const subProduct = isEmbeddedConfluence ? (0, $jiJCD.parse)(location.search, true).query.parentProduct : isLivePage ? 'live' : undefined;
    const fetchAnonymousAssetCallback = async (id)=>{
        try {
            return await (0, $gNjy8.fetchAnonymousAsset)(id);
        } catch (error) {
            onUserFetchError?.(error);
        }
        return undefined;
    };
    // In order to support deduplication of the collaborator, presenceId will be set to the userId if it exists.
    // This means that anonymous users will still rely on presenceId and not get deduplicated.
    const collaboratorPresenceId = userId ?? presenceId;
    (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH);
    (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_CREATED);
    // DO NOT add any asynchronous calls/behavior to the collab provider creation. This has caused incidents
    // in the past where the provider promise never resolves and editing breaks.
    // Context: https://hello.atlassian.net/wiki/spaces/~589311246/pages/2554442259/Investigate+async+issue+HOT-103180
    return (0, $hvdlr.createSocketIOCollabProvider)({
        documentAri: documentAri,
        url: url,
        path: path,
        batchProps: {
            getUsers: fetchUsersClient === 'agg' ? (0, $8VXwD.fetchNativeCollabAGGUsers) : (0, $bNHtR.fetchNativeCollabConfluenceUsers),
            batchSize: 50,
            onError: onUserFetchError
        },
        getAnalyticsWebClient: (0, $04e9M.getAnalyticsWebClient)(),
        permissionTokenRefresh: permissionTokenRefresh,
        need404: true,
        productInfo: {
            product: product,
            subProduct: Array.isArray(subProduct) ? subProduct.join('-') : subProduct
        },
        // either pass the initialDraft that was fetched on hover, or the draftResponse that was fetched on click
        initialDraft: initialDraft || undefined,
        isBufferingEnabled: Boolean(initialDraft),
        __livePage: isLivePage,
        presenceId: collaboratorPresenceId,
        presenceActivity: presenceActivity,
        throwOnNotConnected: true,
        fetchAnonymousAsset: fetchAnonymousAssetCallback
    });
}, $6e4f6ea8730b931f$export$1504d130127dbc5f);
module.exports["getCollabEditProvider"] = $6e4f6ea8730b931f$export$3c298c8b4091db27;

});

parcelRegister("hvdlr", function(module, exports) {

var $1daQW = parcelRequire("1daQW");


var $dh538 = parcelRequire("dh538");


var $T9xHm = parcelRequire("T9xHm");


var $1oCLl = parcelRequire("1oCLl");


var $eOOPa = parcelRequire("eOOPa");


var $4frCv = parcelRequire("4frCv");


var $1jdMD = parcelRequire("1jdMD");

function $28639aaa801abbd1$export$2326b022d5973f36(url, auth, productInfo, isPresenceOnly, analyticsHelper, path, documentAri) {
    const { pathname: pathname } = new URL(url);
    let socketIOOptions = (0, $1jdMD.SOCKET_IO_OPTIONS);
    // Polling first
    let transports = [
        'polling',
        'websocket'
    ];
    let usePMR = false;
    if (isPresenceOnly) {
        // Presence-specific configuration
        if ((0, $dh538.fg)('platform-editor-presence-websocket-only')) // https://socket.io/docs/v4/client-options/#transports
        // WebSocket first, if fails, try polling
        transports = [
            'websocket'
        ];
        socketIOOptions = (0, $1jdMD.SOCKET_IO_OPTIONS_WITH_HIGH_JITTER);
        // PMR routing for presence traffic
        if ((0, $T9xHm.isIsolatedCloud)() && (0, $1oCLl.expValEquals)('platform_editor_use_pmr_for_collab_presence_in_ic', 'isEnabled', true, false) || !(0, $T9xHm.isIsolatedCloud)() && (0, $1oCLl.expValEquals)('platform_editor_use_pmr_for_collab_presence_non_ic', 'isEnabled', true, false)) usePMR = true;
    } else // PMR routing for edit traffic
    if ((0, $1oCLl.expValEquals)('platform_editor_to_use_pmr_for_collab_edit_none_ic', 'isEnabled', true, false)) usePMR = true;
    const extraHeaders = {
        'x-product': (0, $4frCv.getProduct)(productInfo),
        'x-subproduct': (0, $4frCv.getSubProduct)(productInfo)
    };
    if ((0, $1oCLl.expValEquals)('platform_editor_send_client_platform_header', 'isEnabled', true, false)) extraHeaders['x-client-platform'] = 'web';
    const client = (0, $1daQW.io)(url, {
        reconnectionDelayMax: socketIOOptions.RECONNECTION_DELAY_MAX,
        reconnectionDelay: socketIOOptions.RECONNECTION_DELAY,
        randomizationFactor: socketIOOptions.RANDOMIZATION_FACTOR,
        closeOnBeforeunload: false,
        withCredentials: true,
        transports: transports,
        path: usePMR && path ? `${path}/socket.io` : `/${pathname.split('/')[1]}/socket.io`,
        auth: auth,
        extraHeaders: extraHeaders,
        query: {
            sourceId: documentAri?.split('/')[1]
        }
    });
    return client;
}
function $28639aaa801abbd1$export$a301b940c71eb349(config) {
    return new (0, $eOOPa.Provider)({
        ...config,
        createSocket: $28639aaa801abbd1$export$2326b022d5973f36
    });
}
module.exports["createSocketIOCollabProvider"] = $28639aaa801abbd1$export$a301b940c71eb349;

});

parcelRegister("1daQW", function(module, exports) {

var $k7xA3 = parcelRequire("k7xA3");


var $1bCsq = parcelRequire("1bCsq");


var $12VqB = parcelRequire("12VqB");


var $gjFYM = parcelRequire("gjFYM");

/**
 * Managers cache.
 */ const $0e1f6c82808e4270$var$cache = {};
function $0e1f6c82808e4270$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $k7xA3.url)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $0e1f6c82808e4270$var$cache[id] && path in $0e1f6c82808e4270$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $1bCsq.Manager)(source, opts);
    else {
        if (!$0e1f6c82808e4270$var$cache[id]) $0e1f6c82808e4270$var$cache[id] = new (0, $1bCsq.Manager)(source, opts);
        io = $0e1f6c82808e4270$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($0e1f6c82808e4270$export$841407ceb083bd74, {
    Manager: $1bCsq.Manager,
    Socket: $12VqB.Socket,
    io: $0e1f6c82808e4270$export$841407ceb083bd74,
    connect: $0e1f6c82808e4270$export$841407ceb083bd74
});
module.exports["io"] = $0e1f6c82808e4270$export$841407ceb083bd74;

});

parcelRegister("k7xA3", function(module, exports) {
parcelRequire("3nOvZ");
var $glDPj = parcelRequire("glDPj");

function $ea5e82796b5c2d27$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $glDPj.parse)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}
module.exports["url"] = $ea5e82796b5c2d27$export$128fa18b7194ef;

});

parcelRegister("3nOvZ", function(module, exports) {
$parcel$export(module.exports, "Socket", () => (parcelRequire("iHsSr")).Socket);
$parcel$export(module.exports, "installTimerFunctions", () => (parcelRequire("8LtnI")).installTimerFunctions);
$parcel$export(module.exports, "parse", () => (parcelRequire("glDPj")).parse);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("cDUk6")).nextTick);

var $iHsSr = parcelRequire("iHsSr");


var $cQb3o = parcelRequire("cQb3o");


var $l7SQD = parcelRequire("l7SQD");


var $8LtnI = parcelRequire("8LtnI");


var $glDPj = parcelRequire("glDPj");


var $cDUk6 = parcelRequire("cDUk6");

const $276ab44fafc54dec$export$a51d6b395ff4c65a = (0, $iHsSr.Socket).protocol;

});

parcelRegister("iHsSr", function(module, exports) {

var $l7SQD = parcelRequire("l7SQD");


var $8LtnI = parcelRequire("8LtnI");


var $7TImw = parcelRequire("7TImw");


var $glDPj = parcelRequire("glDPj");


var $1odXU = parcelRequire("1odXU");


var $j2gtm = parcelRequire("j2gtm");


var $cDUk6 = parcelRequire("cDUk6");

class $d9d2a4881db5a9d2$export$4798917dbf149b79 extends (0, $1odXU.Emitter) {
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $j2gtm.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new (0, $l7SQD.transports)[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ open() {
        let transport;
        if (this.opts.rememberUpgrade && $d9d2a4881db5a9d2$export$4798917dbf149b79.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) transport = "websocket";
        else if (0 === this.transports.length) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        } else transport = this.transports[0];
        this.readyState = "opening";
        // Retry with the next transport if the transport is disabled (jsonp: false)
        try {
            transport = this.createTransport(transport);
        } catch (e) {
            this.transports.shift();
            this.open();
            return;
        }
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (reason)=>this.onClose("transport close", reason));
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $d9d2a4881db5a9d2$export$4798917dbf149b79.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $d9d2a4881db5a9d2$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this.upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $d9d2a4881db5a9d2$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
        // we check for `readyState` in case an `open`
        // listener already closed the socket
        if ("open" === this.readyState && this.opts.upgrade) {
            let i = 0;
            const l = this.upgrades.length;
            for(; i < l; i++)this.probe(this.upgrades[i]);
        }
    }
    /**
     * Handles a packet.
     *
     * @private
     */ onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            this.resetPingTimeout();
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this.sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this.onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this.upgrades = this.filterUpgrades(data.upgrades);
        this.pingInterval = data.pingInterval;
        this.pingTimeout = data.pingTimeout;
        this.maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this.resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ resetPingTimeout() {
        this.clearTimeoutFn(this.pingTimeoutTimer);
        this.pingTimeoutTimer = this.setTimeoutFn(()=>{
            this.onClose("ping timeout");
        }, this.pingInterval + this.pingTimeout);
        if (this.opts.autoUnref) this.pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ onDrain() {
        this.writeBuffer.splice(0, this.prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this.prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this.getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this.prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ getWritablePackets() {
        const shouldCheckPayloadSize = this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $8LtnI.byteLength)(data);
            if (i > 0 && payloadSize > this.maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    send(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this.onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ onError(err) {
        $d9d2a4881db5a9d2$export$4798917dbf149b79.priorWebsocketSuccess = false;
        this.emitReserved("error", err);
        this.onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this.pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if (typeof removeEventListener === "function") {
                removeEventListener("beforeunload", this.beforeunloadEventListener, false);
                removeEventListener("offline", this.offlineEventListener, false);
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this.prevBufferLen = 0;
        }
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        let i = 0;
        const j = upgrades.length;
        for(; i < j; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts = {}){
        super();
        this.binaryType = (0, $cDUk6.defaultBinaryType);
        this.writeBuffer = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            uri = (0, $glDPj.parse)(uri);
            opts.hostname = uri.host;
            opts.secure = uri.protocol === "https" || uri.protocol === "wss";
            opts.port = uri.port;
            if (uri.query) opts.query = uri.query;
        } else if (opts.host) opts.hostname = (0, $glDPj.parse)(opts.host).host;
        (0, $8LtnI.installTimerFunctions)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = opts.transports || [
            "polling",
            "websocket",
            "webtransport"
        ];
        this.writeBuffer = [];
        this.prevBufferLen = 0;
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $7TImw.decode)(this.opts.query);
        // set on handshake
        this.id = null;
        this.upgrades = null;
        this.pingInterval = null;
        this.pingTimeout = null;
        // set on heartbeat
        this.pingTimeoutTimer = null;
        if (typeof addEventListener === "function") {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this.beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this.beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this.offlineEventListener = ()=>{
                    this.onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                addEventListener("offline", this.offlineEventListener, false);
            }
        }
        this.open();
    }
}
$d9d2a4881db5a9d2$export$4798917dbf149b79.protocol = (0, $j2gtm.protocol);
module.exports["Socket"] = $d9d2a4881db5a9d2$export$4798917dbf149b79;

});

parcelRegister("l7SQD", function(module, exports) {

var $c68Xz = parcelRequire("c68Xz");


var $br29j = parcelRequire("br29j");


var $kVgT5 = parcelRequire("kVgT5");

const $f614cc0f77cd5157$export$46dec00755c1153b = {
    websocket: (0, $br29j.WS),
    webtransport: (0, $kVgT5.WT),
    polling: (0, $c68Xz.Polling)
};
module.exports["transports"] = $f614cc0f77cd5157$export$46dec00755c1153b;

});

parcelRegister("c68Xz", function(module, exports) {

var $cQb3o = parcelRequire("cQb3o");


var $a9lLT = parcelRequire("a9lLT");


var $j2gtm = parcelRequire("j2gtm");


var $epKiJ = parcelRequire("epKiJ");


var $1odXU = parcelRequire("1odXU");


var $8LtnI = parcelRequire("8LtnI");


var $5Y5Gn = parcelRequire("5Y5Gn");

function $8cecfed38aaf6691$var$empty() {}
const $8cecfed38aaf6691$var$hasXHR2 = function() {
    const xhr = new (0, $epKiJ.XHR)({
        xdomain: false
    });
    return null != xhr.responseType;
}();
class $8cecfed38aaf6691$export$265ee5eefd4c309b extends (0, $cQb3o.Transport) {
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this.poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this.polling || !this.writable) {
            let total = 0;
            if (this.polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ poll() {
        this.polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $j2gtm.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this.polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this.poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $j2gtm.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $a9lLT.yeast)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Creates a request.
     *
     * @param {String} method
     * @private
     */ request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd,
            cookieJar: this.cookieJar
        }, this.opts);
        return new $8cecfed38aaf6691$export$7fa6c5b6f8193917(this.uri(), opts);
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        this.polling = false;
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
        /**
         * XHR supports binary
         */ const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $8cecfed38aaf6691$var$hasXHR2 && !forceBase64;
        if (this.opts.withCredentials) this.cookieJar = (0, $epKiJ.createCookieJar)();
    }
}
class $8cecfed38aaf6691$export$7fa6c5b6f8193917 extends (0, $1odXU.Emitter) {
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ create() {
        var _a;
        const opts = (0, $8LtnI.pick)(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this.opts.xd;
        const xhr = this.xhr = new (0, $epKiJ.XHR)(opts);
        try {
            xhr.open(this.method, this.uri, true);
            try {
                if (this.opts.extraHeaders) {
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this.opts.extraHeaders)if (this.opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this.opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this.method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this.opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this.opts.withCredentials;
            if (this.opts.requestTimeout) xhr.timeout = this.opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this.opts.cookieJar) === null || _a === void 0 || _a.parseCookies(xhr);
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this.onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this.onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this.data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this.onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this.index = $8cecfed38aaf6691$export$7fa6c5b6f8193917.requestsCount++;
            $8cecfed38aaf6691$export$7fa6c5b6f8193917.requests[this.index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ onError(err) {
        this.emitReserved("error", err, this.xhr);
        this.cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ cleanup(fromError) {
        if ("undefined" === typeof this.xhr || null === this.xhr) return;
        this.xhr.onreadystatechange = $8cecfed38aaf6691$var$empty;
        if (fromError) try {
            this.xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $8cecfed38aaf6691$export$7fa6c5b6f8193917.requests[this.index];
        this.xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ onLoad() {
        const data = this.xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this.cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this.cleanup();
    }
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(uri, opts){
        super();
        (0, $8LtnI.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.method = opts.method || "GET";
        this.uri = uri;
        this.data = undefined !== opts.data ? opts.data : null;
        this.create();
    }
}
$8cecfed38aaf6691$export$7fa6c5b6f8193917.requestsCount = 0;
$8cecfed38aaf6691$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $8cecfed38aaf6691$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $5Y5Gn.globalThisShim) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $8cecfed38aaf6691$var$unloadHandler, false);
    }
}
function $8cecfed38aaf6691$var$unloadHandler() {
    for(let i in $8cecfed38aaf6691$export$7fa6c5b6f8193917.requests)if ($8cecfed38aaf6691$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $8cecfed38aaf6691$export$7fa6c5b6f8193917.requests[i].abort();
}
module.exports["Polling"] = $8cecfed38aaf6691$export$265ee5eefd4c309b;

});

parcelRegister("cQb3o", function(module, exports) {
parcelRequire("j2gtm");
var $9RqqE = parcelRequire("9RqqE");


var $1odXU = parcelRequire("1odXU");


var $8LtnI = parcelRequire("8LtnI");


var $7TImw = parcelRequire("7TImw");

class $9592ea6a39756981$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $9592ea6a39756981$export$86495b081fef8e52 extends (0, $1odXU.Emitter) {
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $9592ea6a39756981$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $9RqqE.decodePacket)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $7TImw.encode)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $8LtnI.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
    }
}
module.exports["Transport"] = $9592ea6a39756981$export$86495b081fef8e52;

});

parcelRegister("j2gtm", function(module, exports) {
$parcel$export(module.exports, "encodePacket", () => (parcelRequire("eDcVq")).encodePacket);
$parcel$export(module.exports, "decodePacket", () => (parcelRequire("9RqqE")).decodePacket);

var $eDcVq = parcelRequire("eDcVq");


var $9RqqE = parcelRequire("9RqqE");


var $g8mBf = parcelRequire("g8mBf");

const $ddbafb4ec5d26431$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $ddbafb4ec5d26431$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $eDcVq.encodePacket)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($ddbafb4ec5d26431$var$SEPARATOR));
        });
    });
};
const $ddbafb4ec5d26431$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($ddbafb4ec5d26431$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $9RqqE.decodePacket)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $ddbafb4ec5d26431$export$a525fb718e9c623a() {
    // @ts-expect-error
    return new TransformStream({
        transform (packet, controller) {
            (0, $eDcVq.encodePacketToBinary)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $ddbafb4ec5d26431$var$TEXT_DECODER;
function $ddbafb4ec5d26431$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $ddbafb4ec5d26431$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $ddbafb4ec5d26431$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$ddbafb4ec5d26431$var$TEXT_DECODER) $ddbafb4ec5d26431$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    // @ts-expect-error
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* READ_HEADER */ ) {
                    if ($ddbafb4ec5d26431$var$totalLength(chunks) < 1) break;
                    const header = $ddbafb4ec5d26431$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* READ_EXTENDED_LENGTH_16 */ ) {
                    if ($ddbafb4ec5d26431$var$totalLength(chunks) < 2) break;
                    const headerArray = $ddbafb4ec5d26431$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* READ_PAYLOAD */ ;
                } else if (state === 2 /* READ_EXTENDED_LENGTH_64 */ ) {
                    if ($ddbafb4ec5d26431$var$totalLength(chunks) < 8) break;
                    const headerArray = $ddbafb4ec5d26431$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $g8mBf.ERROR_PACKET));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* READ_PAYLOAD */ ;
                } else {
                    if ($ddbafb4ec5d26431$var$totalLength(chunks) < expectedLength) break;
                    const data = $ddbafb4ec5d26431$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $9RqqE.decodePacket)(isBinary ? data : $ddbafb4ec5d26431$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $g8mBf.ERROR_PACKET));
                    break;
                }
            }
        }
    });
}
const $ddbafb4ec5d26431$export$a51d6b395ff4c65a = 4;
module.exports["encodePayload"] = $ddbafb4ec5d26431$export$144d64fe58dad441;
module.exports["decodePayload"] = $ddbafb4ec5d26431$export$d10cc2e7f7566a2d;
module.exports["createPacketEncoderStream"] = $ddbafb4ec5d26431$export$a525fb718e9c623a;
module.exports["createPacketDecoderStream"] = $ddbafb4ec5d26431$export$552d20aac7500f47;
module.exports["protocol"] = $ddbafb4ec5d26431$export$a51d6b395ff4c65a;

});

parcelRegister("eDcVq", function(module, exports) {

var $g8mBf = parcelRequire("g8mBf");

const $aa6ebbe008757ebd$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $aa6ebbe008757ebd$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $aa6ebbe008757ebd$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $aa6ebbe008757ebd$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($aa6ebbe008757ebd$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $aa6ebbe008757ebd$var$encodeBlobAsBase64(data, callback);
    } else if ($aa6ebbe008757ebd$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $aa6ebbe008757ebd$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $aa6ebbe008757ebd$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $g8mBf.PACKET_TYPES)[type] + (data || ""));
};
const $aa6ebbe008757ebd$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $aa6ebbe008757ebd$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $aa6ebbe008757ebd$var$TEXT_ENCODER;
function $aa6ebbe008757ebd$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($aa6ebbe008757ebd$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($aa6ebbe008757ebd$var$toArray).then(callback);
    else if ($aa6ebbe008757ebd$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $aa6ebbe008757ebd$var$isView(packet.data))) return callback($aa6ebbe008757ebd$var$toArray(packet.data));
    $aa6ebbe008757ebd$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$aa6ebbe008757ebd$var$TEXT_ENCODER) $aa6ebbe008757ebd$var$TEXT_ENCODER = new TextEncoder();
        callback($aa6ebbe008757ebd$var$TEXT_ENCODER.encode(encoded));
    });
}
module.exports["encodePacket"] = $aa6ebbe008757ebd$export$57852049361a8e62;
module.exports["encodePacketToBinary"] = $aa6ebbe008757ebd$export$ec0c9b9013ee0ef5;

});

parcelRegister("g8mBf", function(module, exports) {
const $bbeeec8bf61d59e6$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$bbeeec8bf61d59e6$export$c169aefb7330cccb["open"] = "0";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["close"] = "1";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["ping"] = "2";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["pong"] = "3";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["message"] = "4";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["upgrade"] = "5";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["noop"] = "6";
const $bbeeec8bf61d59e6$export$47791e8004edd485 = Object.create(null);
Object.keys($bbeeec8bf61d59e6$export$c169aefb7330cccb).forEach((key)=>{
    $bbeeec8bf61d59e6$export$47791e8004edd485[$bbeeec8bf61d59e6$export$c169aefb7330cccb[key]] = key;
});
const $bbeeec8bf61d59e6$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};
module.exports["PACKET_TYPES"] = $bbeeec8bf61d59e6$export$c169aefb7330cccb;
module.exports["PACKET_TYPES_REVERSE"] = $bbeeec8bf61d59e6$export$47791e8004edd485;
module.exports["ERROR_PACKET"] = $bbeeec8bf61d59e6$export$c718b5840781f8a7;

});

parcelRegister("9RqqE", function(module, exports) {

var $g8mBf = parcelRequire("g8mBf");


var $ky20u = parcelRequire("ky20u");

const $72dd9088c237fe2b$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $72dd9088c237fe2b$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $72dd9088c237fe2b$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $72dd9088c237fe2b$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $g8mBf.PACKET_TYPES_REVERSE)[type];
    if (!packetType) return 0, $g8mBf.ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: (0, $g8mBf.PACKET_TYPES_REVERSE)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $g8mBf.PACKET_TYPES_REVERSE)[type]
    };
};
const $72dd9088c237fe2b$var$decodeBase64Packet = (data, binaryType)=>{
    if ($72dd9088c237fe2b$var$withNativeArrayBuffer) {
        const decoded = (0, $ky20u.decode)(data);
        return $72dd9088c237fe2b$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $72dd9088c237fe2b$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};
module.exports["decodePacket"] = $72dd9088c237fe2b$export$4647901878f33f31;

});

parcelRegister("ky20u", function(module, exports) {
// imported from https://github.com/socketio/base64-arraybuffer
const $ef588a29a27a4f0c$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $ef588a29a27a4f0c$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $ef588a29a27a4f0c$var$chars.length; i++)$ef588a29a27a4f0c$var$lookup[$ef588a29a27a4f0c$var$chars.charCodeAt(i)] = i;
const $ef588a29a27a4f0c$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $ef588a29a27a4f0c$var$chars[bytes[i] >> 2];
        base64 += $ef588a29a27a4f0c$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $ef588a29a27a4f0c$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $ef588a29a27a4f0c$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $ef588a29a27a4f0c$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $ef588a29a27a4f0c$var$lookup[base64.charCodeAt(i)];
        encoded2 = $ef588a29a27a4f0c$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $ef588a29a27a4f0c$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $ef588a29a27a4f0c$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};
module.exports["decode"] = $ef588a29a27a4f0c$export$2f872c0f2117be69;

});

parcelRegister("1odXU", function(module, exports) {
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $1032dd8c99dcfaba$export$4293555f241ae35a(obj) {
    if (obj) return $1032dd8c99dcfaba$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $1032dd8c99dcfaba$var$mixin(obj) {
    for(var key in $1032dd8c99dcfaba$export$4293555f241ae35a.prototype)obj[key] = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.on = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.off = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.removeListener = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.removeAllListeners = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$1032dd8c99dcfaba$export$4293555f241ae35a.prototype.emitReserved = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};
module.exports["Emitter"] = $1032dd8c99dcfaba$export$4293555f241ae35a;

});

parcelRegister("8LtnI", function(module, exports) {

var $5Y5Gn = parcelRequire("5Y5Gn");

function $6619810c021a58f6$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $6619810c021a58f6$var$NATIVE_SET_TIMEOUT = (0, $5Y5Gn.globalThisShim).setTimeout;
const $6619810c021a58f6$var$NATIVE_CLEAR_TIMEOUT = (0, $5Y5Gn.globalThisShim).clearTimeout;
function $6619810c021a58f6$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $6619810c021a58f6$var$NATIVE_SET_TIMEOUT.bind((0, $5Y5Gn.globalThisShim));
        obj.clearTimeoutFn = $6619810c021a58f6$var$NATIVE_CLEAR_TIMEOUT.bind((0, $5Y5Gn.globalThisShim));
    } else {
        obj.setTimeoutFn = (0, $5Y5Gn.globalThisShim).setTimeout.bind((0, $5Y5Gn.globalThisShim));
        obj.clearTimeoutFn = (0, $5Y5Gn.globalThisShim).clearTimeout.bind((0, $5Y5Gn.globalThisShim));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $6619810c021a58f6$var$BASE64_OVERHEAD = 1.33;
function $6619810c021a58f6$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $6619810c021a58f6$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $6619810c021a58f6$var$BASE64_OVERHEAD);
}
function $6619810c021a58f6$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
module.exports["pick"] = $6619810c021a58f6$export$357523c63a2253b9;
module.exports["installTimerFunctions"] = $6619810c021a58f6$export$2f67576668b97183;
module.exports["byteLength"] = $6619810c021a58f6$export$a48f0734ac7c2329;

});

parcelRegister("5Y5Gn", function(module, exports) {
const $4586f6c761acbc2b$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
module.exports["globalThisShim"] = $4586f6c761acbc2b$export$394f9358f6231289;

});

parcelRegister("7TImw", function(module, exports) {
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $5c0014e3a134c3e4$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $5c0014e3a134c3e4$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}
module.exports["encode"] = $5c0014e3a134c3e4$export$c564cdbbe6da493;
module.exports["decode"] = $5c0014e3a134c3e4$export$2f872c0f2117be69;

});

parcelRegister("a9lLT", function(module, exports) {
// imported from https://github.com/unshiftio/yeast
'use strict';
const $763ba2042e4d4eb9$var$alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split(''), $763ba2042e4d4eb9$var$length = 64, $763ba2042e4d4eb9$var$map = {};
let $763ba2042e4d4eb9$var$seed = 0, $763ba2042e4d4eb9$var$i = 0, $763ba2042e4d4eb9$var$prev;
function $763ba2042e4d4eb9$export$c564cdbbe6da493(num) {
    let encoded = '';
    do {
        encoded = $763ba2042e4d4eb9$var$alphabet[num % $763ba2042e4d4eb9$var$length] + encoded;
        num = Math.floor(num / $763ba2042e4d4eb9$var$length);
    }while (num > 0);
    return encoded;
}
function $763ba2042e4d4eb9$export$2f872c0f2117be69(str) {
    let decoded = 0;
    for($763ba2042e4d4eb9$var$i = 0; $763ba2042e4d4eb9$var$i < str.length; $763ba2042e4d4eb9$var$i++)decoded = decoded * $763ba2042e4d4eb9$var$length + $763ba2042e4d4eb9$var$map[str.charAt($763ba2042e4d4eb9$var$i)];
    return decoded;
}
function $763ba2042e4d4eb9$export$5bb64b92cb4135a() {
    const now = $763ba2042e4d4eb9$export$c564cdbbe6da493(+new Date());
    if (now !== $763ba2042e4d4eb9$var$prev) return $763ba2042e4d4eb9$var$seed = 0, $763ba2042e4d4eb9$var$prev = now;
    return now + '.' + $763ba2042e4d4eb9$export$c564cdbbe6da493($763ba2042e4d4eb9$var$seed++);
}
//
// Map each character to its index.
//
for(; $763ba2042e4d4eb9$var$i < $763ba2042e4d4eb9$var$length; $763ba2042e4d4eb9$var$i++)$763ba2042e4d4eb9$var$map[$763ba2042e4d4eb9$var$alphabet[$763ba2042e4d4eb9$var$i]] = $763ba2042e4d4eb9$var$i;
module.exports["yeast"] = $763ba2042e4d4eb9$export$5bb64b92cb4135a;

});

parcelRegister("epKiJ", function(module, exports) {
// browser shim for xmlhttprequest module

var $e5XvD = parcelRequire("e5XvD");


var $5Y5Gn = parcelRequire("5Y5Gn");

function $a7e750ed0f96e195$export$a2d42eb087c10497(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $e5XvD.hasCORS))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $5Y5Gn.globalThisShim)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}
function $a7e750ed0f96e195$export$19413efcf2fac759() {}
module.exports["XHR"] = $a7e750ed0f96e195$export$a2d42eb087c10497;
module.exports["createCookieJar"] = $a7e750ed0f96e195$export$19413efcf2fac759;

});

parcelRegister("e5XvD", function(module, exports) {
// imported from https://github.com/component/has-cors
let $a42fb1a1e9c41568$var$value = false;
try {
    $a42fb1a1e9c41568$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $a42fb1a1e9c41568$export$5235bbd4a1ef06e = $a42fb1a1e9c41568$var$value;
module.exports["hasCORS"] = $a42fb1a1e9c41568$export$5235bbd4a1ef06e;

});

parcelRegister("br29j", function(module, exports) {

var $cQb3o = parcelRequire("cQb3o");


var $a9lLT = parcelRequire("a9lLT");


var $8LtnI = parcelRequire("8LtnI");


var $cDUk6 = parcelRequire("cDUk6");

parcelRequire("j2gtm");
var $eDcVq = parcelRequire("eDcVq");


var $iA9co = parcelRequire("iA9co");

var $8533e219b2af82c1$require$Buffer = $iA9co.Buffer;
// detect ReactNative environment
const $8533e219b2af82c1$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $8533e219b2af82c1$export$911baa0677ac404c extends (0, $cQb3o.Transport) {
    get name() {
        return "websocket";
    }
    doOpen() {
        if (!this.check()) // let probe timeout
        return;
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $8533e219b2af82c1$var$isReactNative ? {} : (0, $8LtnI.pick)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = (0, $cDUk6.usingBrowserWebSocket) && !$8533e219b2af82c1$var$isReactNative ? protocols ? new (0, $cDUk6.WebSocket)(uri, protocols) : new (0, $cDUk6.WebSocket)(uri) : new (0, $cDUk6.WebSocket)(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $eDcVq.encodePacket)(packet, this.supportsBinary, (data)=>{
                // always create a new object (GH-437)
                const opts = {};
                if (!(0, $cDUk6.usingBrowserWebSocket)) {
                    if (packet.options) opts.compress = packet.options.compress;
                    if (this.opts.perMessageDeflate) {
                        const len = // @ts-ignore
                        "string" === typeof data ? $8533e219b2af82c1$require$Buffer.byteLength(data) : data.length;
                        if (len < this.opts.perMessageDeflate.threshold) opts.compress = false;
                    }
                }
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    if (0, $cDUk6.usingBrowserWebSocket) // TypeError is thrown when passing the second argument on Safari
                    this.ws.send(data);
                    else this.ws.send(data, opts);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $cDUk6.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $a9lLT.yeast)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Feature detection for WebSocket.
     *
     * @return {Boolean} whether this transport is available.
     * @private
     */ check() {
        return !!(0, $cDUk6.WebSocket);
    }
    /**
     * WebSocket transport constructor.
     *
     * @param {Object} opts - connection options
     * @protected
     */ constructor(opts){
        super(opts);
        this.supportsBinary = !opts.forceBase64;
    }
}
module.exports["WS"] = $8533e219b2af82c1$export$911baa0677ac404c;

});

parcelRegister("cDUk6", function(module, exports) {

var $5Y5Gn = parcelRequire("5Y5Gn");

const $9344d126b47ec216$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $9344d126b47ec216$export$3909fb301d3dc8c9 = (0, $5Y5Gn.globalThisShim).WebSocket || (0, $5Y5Gn.globalThisShim).MozWebSocket;
const $9344d126b47ec216$export$3407ba5dfb7a683d = true;
const $9344d126b47ec216$export$790dcbc41e2d75d5 = "arraybuffer";
module.exports["nextTick"] = $9344d126b47ec216$export$bdd553fddd433dcb;
module.exports["WebSocket"] = $9344d126b47ec216$export$3909fb301d3dc8c9;
module.exports["usingBrowserWebSocket"] = $9344d126b47ec216$export$3407ba5dfb7a683d;
module.exports["defaultBinaryType"] = $9344d126b47ec216$export$790dcbc41e2d75d5;

});

parcelRegister("kVgT5", function(module, exports) {

var $cQb3o = parcelRequire("cQb3o");


var $cDUk6 = parcelRequire("cDUk6");


var $j2gtm = parcelRequire("j2gtm");

class $f3b63b067a93fecb$export$961c930859384407 extends (0, $cQb3o.Transport) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        // @ts-ignore
        if (typeof WebTransport !== "function") return;
        // @ts-ignore
        this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        this.transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this.transport.ready.then(()=>{
            this.transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $j2gtm.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $j2gtm.createPacketEncoderStream)();
                encoderStream.readable.pipeTo(stream.writable);
                this.writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this.writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this.writer.write(packet).then(()=>{
                if (lastPacket) (0, $cDUk6.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this.transport) === null || _a === void 0 || _a.close();
    }
}
module.exports["WT"] = $f3b63b067a93fecb$export$961c930859384407;

});

parcelRegister("glDPj", function(module, exports) {
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $be6d803df662636b$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $be6d803df662636b$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $be6d803df662636b$export$98e6a39c04603d36(str) {
    if (str.length > 2000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $be6d803df662636b$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$be6d803df662636b$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $be6d803df662636b$var$pathNames(uri, uri['path']);
    uri.queryKey = $be6d803df662636b$var$queryKey(uri, uri['query']);
    return uri;
}
function $be6d803df662636b$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $be6d803df662636b$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}
module.exports["parse"] = $be6d803df662636b$export$98e6a39c04603d36;

});

parcelRegister("1bCsq", function(module, exports) {
parcelRequire("3nOvZ");
var $8LtnI = parcelRequire("8LtnI");
var $cDUk6 = parcelRequire("cDUk6");
var $iHsSr = parcelRequire("iHsSr");


var $12VqB = parcelRequire("12VqB");


var $gjFYM = parcelRequire("gjFYM");


var $e6joS = parcelRequire("e6joS");


var $liT4p = parcelRequire("liT4p");


var $1odXU = parcelRequire("1odXU");

class $0dd4a65fac43516f$export$d0d38e7dec7a1a61 extends (0, $1odXU.Emitter) {
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $iHsSr.Socket)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $e6joS.on)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $e6joS.on)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $e6joS.on)(socket, "ping", this.onping.bind(this)), (0, $e6joS.on)(socket, "data", this.ondata.bind(this)), (0, $e6joS.on)(socket, "error", this.onerror.bind(this)), (0, $e6joS.on)(socket, "close", this.onclose.bind(this)), (0, $e6joS.on)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $cDUk6.nextTick)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $12VqB.Socket)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
        if (this.engine) this.engine.close();
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called upon engine close.
     *
     * @private
     */ onclose(reason, description) {
        this.cleanup();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $8LtnI.installTimerFunctions)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $liT4p.Backoff)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $gjFYM;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
}
module.exports["Manager"] = $0dd4a65fac43516f$export$d0d38e7dec7a1a61;

});

parcelRegister("12VqB", function(module, exports) {

var $gjFYM = parcelRequire("gjFYM");


var $e6joS = parcelRequire("e6joS");


var $1odXU = parcelRequire("1odXU");

/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $0c32865cdab9ae8e$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $0c32865cdab9ae8e$export$4798917dbf149b79 extends (0, $1odXU.Emitter) {
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $e6joS.on)(io, "open", this.onopen.bind(this)),
            (0, $e6joS.on)(io, "packet", this.onpacket.bind(this)),
            (0, $e6joS.on)(io, "error", this.onerror.bind(this)),
            (0, $e6joS.on)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        if ($0c32865cdab9ae8e$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $gjFYM.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
        const discardPacket = this.flags.volatile && (!isTransportWritable || !this.connected);
        if (discardPacket) ;
        else if (this.connected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $gjFYM.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $gjFYM.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $gjFYM.PacketType).EVENT:
            case (0, $gjFYM.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $gjFYM.PacketType).ACK:
            case (0, $gjFYM.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $gjFYM.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $gjFYM.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $gjFYM.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $gjFYM.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
}
module.exports["Socket"] = $0c32865cdab9ae8e$export$4798917dbf149b79;

});

parcelRegister("gjFYM", function(module, exports) {
$parcel$export(module.exports, "PacketType", () => $0310c1ff85201954$export$84d4095e16c6fc19);

var $1odXU = parcelRequire("1odXU");


var $fWhxz = parcelRequire("fWhxz");


var $6qMhJ = parcelRequire("6qMhJ");

/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $0310c1ff85201954$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $0310c1ff85201954$export$a51d6b395ff4c65a = 5;
var $0310c1ff85201954$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($0310c1ff85201954$export$84d4095e16c6fc19 || ($0310c1ff85201954$export$84d4095e16c6fc19 = {}));
class $0310c1ff85201954$export$a50aceb0e02a00aa {
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $0310c1ff85201954$export$84d4095e16c6fc19.EVENT || obj.type === $0310c1ff85201954$export$84d4095e16c6fc19.ACK) {
            if ((0, $6qMhJ.hasBinary)(obj)) return this.encodeAsBinary({
                type: obj.type === $0310c1ff85201954$export$84d4095e16c6fc19.EVENT ? $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_EVENT : $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $fWhxz.deconstructPacket)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $0310c1ff85201954$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $0310c1ff85201954$export$f9de6ca0bc043724 extends (0, $1odXU.Emitter) {
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $0310c1ff85201954$export$84d4095e16c6fc19.EVENT : $0310c1ff85201954$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $0310c1ff85201954$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $6qMhJ.isBinary)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($0310c1ff85201954$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($0310c1ff85201954$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $0310c1ff85201954$export$84d4095e16c6fc19.CONNECT:
                return $0310c1ff85201954$var$isObject(payload);
            case $0310c1ff85201954$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $0310c1ff85201954$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $0310c1ff85201954$var$isObject(payload);
            case $0310c1ff85201954$export$84d4095e16c6fc19.EVENT:
            case $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $0310c1ff85201954$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $0310c1ff85201954$export$84d4095e16c6fc19.ACK:
            case $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $0310c1ff85201954$var$BinaryReconstructor {
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $fWhxz.reconstructPacket)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
}
module.exports["protocol"] = $0310c1ff85201954$export$a51d6b395ff4c65a;
module.exports["Encoder"] = $0310c1ff85201954$export$a50aceb0e02a00aa;
module.exports["Decoder"] = $0310c1ff85201954$export$f9de6ca0bc043724;

});

parcelRegister("fWhxz", function(module, exports) {

var $6qMhJ = parcelRequire("6qMhJ");

function $b9a9e0f6ffd208ba$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $b9a9e0f6ffd208ba$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $b9a9e0f6ffd208ba$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $6qMhJ.isBinary)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $b9a9e0f6ffd208ba$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $b9a9e0f6ffd208ba$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $b9a9e0f6ffd208ba$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $b9a9e0f6ffd208ba$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $b9a9e0f6ffd208ba$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $b9a9e0f6ffd208ba$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $b9a9e0f6ffd208ba$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}
module.exports["deconstructPacket"] = $b9a9e0f6ffd208ba$export$ac2edb9eb7af56f6;
module.exports["reconstructPacket"] = $b9a9e0f6ffd208ba$export$a00da3b1ec037a04;

});

parcelRegister("6qMhJ", function(module, exports) {
const $4aeaa029a9e7e8ab$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $4aeaa029a9e7e8ab$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $4aeaa029a9e7e8ab$var$toString = Object.prototype.toString;
const $4aeaa029a9e7e8ab$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $4aeaa029a9e7e8ab$var$toString.call(Blob) === "[object BlobConstructor]";
const $4aeaa029a9e7e8ab$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $4aeaa029a9e7e8ab$var$toString.call(File) === "[object FileConstructor]";
function $4aeaa029a9e7e8ab$export$37488ff1135b1696(obj) {
    return $4aeaa029a9e7e8ab$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $4aeaa029a9e7e8ab$var$isView(obj)) || $4aeaa029a9e7e8ab$var$withNativeBlob && obj instanceof Blob || $4aeaa029a9e7e8ab$var$withNativeFile && obj instanceof File;
}
function $4aeaa029a9e7e8ab$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($4aeaa029a9e7e8ab$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($4aeaa029a9e7e8ab$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $4aeaa029a9e7e8ab$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $4aeaa029a9e7e8ab$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}
module.exports["isBinary"] = $4aeaa029a9e7e8ab$export$37488ff1135b1696;
module.exports["hasBinary"] = $4aeaa029a9e7e8ab$export$5234c529abdb5610;

});

parcelRegister("e6joS", function(module, exports) {
function $a440acb1a369a030$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}
module.exports["on"] = $a440acb1a369a030$export$af631764ddc44097;

});

parcelRegister("liT4p", function(module, exports) {
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $f825ff317086dbca$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $f825ff317086dbca$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $f825ff317086dbca$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $f825ff317086dbca$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $f825ff317086dbca$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $f825ff317086dbca$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};
module.exports["Backoff"] = $f825ff317086dbca$export$2d38012449449c89;

});

parcelRegister("1jdMD", function(module, exports) {
/**
 * https://socket.io/docs/v4/client-options/#randomizationfactor
 * 1st reconnection attempt happens between 100 - 300 ms
 * 2nd reconnection attempt happens between 200 - 600 ms
 * 3rd reconnection attempt happens between 400 - 1200 ms
 * 4th 800 - 2400 ms
 * 5th 1600 - 4800 ms
 * 6th 3200 - 9600 ms
 * 7th 6400 - 19200 ms
 * 8th 12800 - 38400 ms
 * 9th 25600 - 76800 ms
 * 10th 51200 - 128000 ms (capped at max delay)
 * nth 128000 ms
 */ const $f64b9931b63de03f$export$33eb5f668d5e0d74 = {
    RECONNECTION_DELAY_MAX: 128000,
    RECONNECTION_DELAY: 200,
    RANDOMIZATION_FACTOR: 0.5
};
const $f64b9931b63de03f$export$273323b1c5196ad5 = {
    RECONNECTION_DELAY_MAX: 128000,
    RECONNECTION_DELAY: 1000,
    RANDOMIZATION_FACTOR: 0.75
};
module.exports["SOCKET_IO_OPTIONS"] = $f64b9931b63de03f$export$33eb5f668d5e0d74;
module.exports["SOCKET_IO_OPTIONS_WITH_HIGH_JITTER"] = $f64b9931b63de03f$export$273323b1c5196ad5;

});

parcelRegister("1VB1N", function(module, exports) {
const $aa17610eab1e6010$var$COLLAB_PATH = 'ccollab'; // the extra c is for Confluence
const $aa17610eab1e6010$export$33a46e9ce425ca1f = ()=>{
    return `${window.location.origin}/${$aa17610eab1e6010$var$COLLAB_PATH}`;
};
const $aa17610eab1e6010$export$2fa932d5a7c03848 = (cloudId, activationId)=>{
    const editPrefix = '/ncs';
    return `${editPrefix}/${cloudId}/${activationId}/confluence`;
};
module.exports["getCollabProviderUrl"] = $aa17610eab1e6010$export$33a46e9ce425ca1f;
module.exports["getCollabEditServicePath"] = $aa17610eab1e6010$export$2fa932d5a7c03848;

});

parcelRegister("8VXwD", function(module, exports) {
/** @graphql agg **/ 
var $eSUdr = parcelRequire("eSUdr");


var $gKr8t = parcelRequire("gKr8t");

const $b6adfd51a2226747$export$c510c686c47533e5 = (accountIds)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $gKr8t.getAGGClient)().query({
        query: (0, $eSUdr.default)`query fetchNativeCollabAGGUsersQuery($accountIds:[ID!]!){users(accountIds:$accountIds){accountId name picture}}`,
        variables: {
            accountIds: accountIds
        }
    }).then(({ data: data })=>{
        return data?.users?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user.picture ?? '',
                email: '',
                name: user.name ?? '',
                userId: user.accountId
            })) ?? [];
    });
};
module.exports["fetchNativeCollabAGGUsers"] = $b6adfd51a2226747$export$c510c686c47533e5;

});

parcelRegister("bNHtR", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");


var $hp2SH = parcelRequire("hp2SH");

const $5bd57447223249dc$export$1db9c46a0728e686 = (accountIds)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $eSUdr.default)`query fetchNativeCollabConfluenceUsersQuery($accountIds:[String]){confluenceUsers(accountIds:$accountIds){nodes{profilePicture{isDefault path(type:RELATIVE)}...on KnownUser{accountId}...on UnknownUser{accountId}displayName}}}`,
        variables: {
            accountIds: accountIds
        }
    }).then(({ data: data })=>{
        return data?.confluenceUsers?.nodes?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user.profilePicture?.path ?? '',
                email: '',
                isGuest: undefined,
                name: user.displayName ?? '',
                userId: user.accountId
            })) ?? [];
    });
};
module.exports["fetchNativeCollabConfluenceUsers"] = $5bd57447223249dc$export$1db9c46a0728e686;

});

parcelRegister("gNjy8", function(module, exports) {

var $jyw2s = parcelRequire("jyw2s");

var $aFUXX = parcelRequire("aFUXX");


var $83Vfg = parcelRequire("83Vfg");

const $f7e4e12795ac08a6$export$e42cca8419da94fc = (presenceId)=>{
    const hashCode = presenceId ? (0, $jyw2s.getHashCode)(presenceId) : 0;
    const primaryIndex = hashCode;
    const secondaryIndex = hashCode % (0, $aFUXX.participantColors).length;
    const svgBackgroundColor = (0, $aFUXX.participantColors)[secondaryIndex].svgBackgroundColor;
    return (0, $83Vfg.getAnonymousAvatarWithStyling)({
        styleProperties: {
            'background-color': svgBackgroundColor
        },
        index: primaryIndex
    });
};
module.exports["fetchAnonymousAsset"] = $f7e4e12795ac08a6$export$e42cca8419da94fc;

});

parcelRegister("83Vfg", function(module, exports) {

var $8ocXC = parcelRequire("8ocXC");


var $fDtVg = parcelRequire("fDtVg");


var $99F08 = parcelRequire("99F08");

const $eeb5105c6a539702$export$101d00feadd67b75 = (svgRoot)=>{
    // by this point we have a safe SVG string: we can safely string interpolate to encode as a
    // data:image to enable passing it to an <img> src attribute
    return `data:image/svg+xml;base64,${btoa(new XMLSerializer().serializeToString(svgRoot))}`;
};
const $eeb5105c6a539702$export$ad5dfe87b2150403 = (cssProperties)=>{
    let styleString = '';
    Object.keys(cssProperties).forEach((key)=>{
        styleString += `${key}: ${cssProperties[key]}; `;
    });
    return styleString;
};
const $eeb5105c6a539702$export$1ce458cf91bd8e41 = (svgRoot, cssProperties)=>{
    const styleRule = new CSSStyleSheet();
    const styleString = $eeb5105c6a539702$export$ad5dfe87b2150403(cssProperties);
    // even if styling is malicious, it will be sanitized by the CSSStyleSheet with the string being empty, ensuring safety
    styleRule.insertRule(`svg { ${styleString} }`);
    // we need to cast to CSSStyleRule to access the .style property
    const styleRuleString = styleRule.cssRules[0].style.cssText;
    svgRoot.setAttribute('style', styleRuleString);
};
const $eeb5105c6a539702$export$7572e098f6cf1a37 = (index)=>{
    return index !== undefined ? index % (0, $8ocXC.ANONYMOUS_ASSETS).length : Math.floor(Math.random() * (0, $8ocXC.ANONYMOUS_ASSETS).length);
};
const $eeb5105c6a539702$export$e79675c646a31542 = (svgString)=>{
    return new DOMParser().parseFromString(svgString, 'image/svg+xml');
};
const $eeb5105c6a539702$export$65fe496f5eb91c21 = async (props)=>{
    const index = $eeb5105c6a539702$export$7572e098f6cf1a37(props?.index);
    const { id: id, messageDescriptor: messageDescriptor, src: src } = (0, $8ocXC.ANONYMOUS_ASSETS)[index];
    const intl = await (0, $fDtVg.getIntl)();
    const response = await (0, $99F08.fetchWithRetry)({
        url: src,
        shouldRetryOnApiError: true,
        retries: props.retries || 3,
        options: props.options,
        baseDelay: props.baseDelay,
        maxDelay: props.maxDelay
    });
    const svgString = await response.result?.text();
    if (!response.success) throw new Error(`Error while fetching svg ${id} with src ${src}`);
    if (!svgString) throw new Error(`svg returned null with svg ${id} with src ${src}`);
    const doc = $eeb5105c6a539702$export$e79675c646a31542(svgString);
    const svg = doc.documentElement;
    $eeb5105c6a539702$export$1ce458cf91bd8e41(svg, props.styleProperties);
    return {
        id: id,
        name: intl.formatMessage(messageDescriptor),
        src: $eeb5105c6a539702$export$101d00feadd67b75(svg)
    };
};
const $eeb5105c6a539702$export$da26b707e2b53fcf = async (props)=>{
    const index = $eeb5105c6a539702$export$7572e098f6cf1a37(props?.index);
    const asset = (0, $8ocXC.ANONYMOUS_ASSETS)[index];
    const intl = await (0, $fDtVg.getIntl)();
    return {
        ...asset,
        name: intl.formatMessage(asset.messageDescriptor)
    };
};
const $eeb5105c6a539702$export$aa51d138a7f855d7 = async ()=>{
    const intl = await (0, $fDtVg.getIntl)();
    return (0, $8ocXC.ANONYMOUS_ASSETS).map((asset)=>({
            id: asset.id,
            name: intl.formatMessage(asset.messageDescriptor),
            src: asset.src
        }));
};
module.exports["getAnonymousAvatarWithStyling"] = $eeb5105c6a539702$export$65fe496f5eb91c21;

});

parcelRegister("8ocXC", function(module, exports) {

var $lfFy6 = parcelRequire("lfFy6");


var $45p5c = parcelRequire("45p5c");

var $66aLS = parcelRequire("66aLS");

var $eA5k9 = parcelRequire("eA5k9");

var $dLHML = parcelRequire("dLHML");

var $5QM3U = parcelRequire("5QM3U");

var $1zbJy = parcelRequire("1zbJy");

var $absgL = parcelRequire("absgL");

var $i9wU3 = parcelRequire("i9wU3");

var $7BD8h = parcelRequire("7BD8h");

var $ipNYr = parcelRequire("ipNYr");

var $5Fo99 = parcelRequire("5Fo99");

var $futbp = parcelRequire("futbp");

var $1tL0q = parcelRequire("1tL0q");

var $gsqYV = parcelRequire("gsqYV");

var $aV0Ix = parcelRequire("aV0Ix");

var $7f8BP = parcelRequire("7f8BP");

var $w2g3p = parcelRequire("w2g3p");

var $7pNkU = parcelRequire("7pNkU");

var $3saEQ = parcelRequire("3saEQ");

var $bBrvm = parcelRequire("bBrvm");

var $2MJ1F = parcelRequire("2MJ1F");

var $62PyO = parcelRequire("62PyO");

var $ct5mQ = parcelRequire("ct5mQ");

var $geCWF = parcelRequire("geCWF");

var $cA6yA = parcelRequire("cA6yA");

var $gE9fP = parcelRequire("gE9fP");

var $6Cmrb = parcelRequire("6Cmrb");

var $7Za1I = parcelRequire("7Za1I");

var $kgPFA = parcelRequire("kgPFA");

var $2hRuV = parcelRequire("2hRuV");

var $8H1nG = parcelRequire("8H1nG");

var $jfdMm = parcelRequire("jfdMm");

var $jAnMk = parcelRequire("jAnMk");

var $kiped = parcelRequire("kiped");

var $ijRK6 = parcelRequire("ijRK6");

var $hQTrZ = parcelRequire("hQTrZ");

var $3ussC = parcelRequire("3ussC");

var $bfQlR = parcelRequire("bfQlR");

var $g2zNl = parcelRequire("g2zNl");

var $dnUXX = parcelRequire("dnUXX");

var $ldCFU = parcelRequire("ldCFU");

var $gcvuo = parcelRequire("gcvuo");

var $3aulr = parcelRequire("3aulr");

var $jj7JF = parcelRequire("jj7JF");

var $gFh8H = parcelRequire("gFh8H");

var $ib1i9 = parcelRequire("ib1i9");

var $7vWf2 = parcelRequire("7vWf2");

var $MAw5A = parcelRequire("MAw5A");

var $4R6fR = parcelRequire("4R6fR");

var $3G8sv = parcelRequire("3G8sv");

var $5L3ZL = parcelRequire("5L3ZL");

var $1tIXy = parcelRequire("1tIXy");

var $gIr5o = parcelRequire("gIr5o");

var $jMi9Z = parcelRequire("jMi9Z");

var $5fTd1 = parcelRequire("5fTd1");

var $70IXo = parcelRequire("70IXo");

var $k45BN = parcelRequire("k45BN");

var $5t7IX = parcelRequire("5t7IX");

var $7y9m7 = parcelRequire("7y9m7");

var $kRP7t = parcelRequire("kRP7t");

var $dLJHp = parcelRequire("dLJHp");

var $MvguA = parcelRequire("MvguA");

var $i2wVj = parcelRequire("i2wVj");

var $bqNy3 = parcelRequire("bqNy3");

var $5RzHY = parcelRequire("5RzHY");

var $jN43s = parcelRequire("jN43s");

var $018bO = parcelRequire("018bO");

var $c3T8r = parcelRequire("c3T8r");

var $h0256 = parcelRequire("h0256");

var $8O3eM = parcelRequire("8O3eM");

var $8BcsQ = parcelRequire("8BcsQ");

var $ctuOo = parcelRequire("ctuOo");

var $9wms3 = parcelRequire("9wms3");

var $1j7TY = parcelRequire("1j7TY");

var $4ux8O = parcelRequire("4ux8O");

var $44Sb4 = parcelRequire("44Sb4");

var $dQMZo = parcelRequire("dQMZo");

var $zYoHs = parcelRequire("zYoHs");

var $04PGh = parcelRequire("04PGh");

var $ddSO1 = parcelRequire("ddSO1");

var $ivVMv = parcelRequire("ivVMv");

var $eJnd2 = parcelRequire("eJnd2");

var $98ut7 = parcelRequire("98ut7");

var $9q1Vk = parcelRequire("9q1Vk");

var $eMHgQ = parcelRequire("eMHgQ");

var $3LKHJ = parcelRequire("3LKHJ");

var $3ZCOi = parcelRequire("3ZCOi");

var $5xoX8 = parcelRequire("5xoX8");

var $5qhol = parcelRequire("5qhol");

var $dGRYO = parcelRequire("dGRYO");

var $6dhVt = parcelRequire("6dhVt");

var $ighEF = parcelRequire("ighEF");

var $jiyfa = parcelRequire("jiyfa");

var $aRWto = parcelRequire("aRWto");

var $3VNps = parcelRequire("3VNps");

var $62BuW = parcelRequire("62BuW");

var $54a3y = parcelRequire("54a3y");

var $cjnzF = parcelRequire("cjnzF");

var $faukZ = parcelRequire("faukZ");

var $Ox4am = parcelRequire("Ox4am");

var $hembw = parcelRequire("hembw");

var $5gEBh = parcelRequire("5gEBh");

var $76eQq = parcelRequire("76eQq");

var $68Yx0 = parcelRequire("68Yx0");

var $l08I5 = parcelRequire("l08I5");

const $40b74b738da6af36$export$4522d3d70312bbdc = [
    {
        id: 'alligator',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2hRuV))),
        messageDescriptor: (0, $lfFy6.messages).alligator
    },
    {
        id: 'alpaca',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($70IXo))),
        messageDescriptor: (0, $lfFy6.messages).alpaca
    },
    {
        id: 'ape',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5RzHY))),
        messageDescriptor: (0, $lfFy6.messages).ape
    },
    {
        id: 'apple',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($45p5c))),
        messageDescriptor: (0, $lfFy6.messages).apple
    },
    {
        id: 'avocado',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($66aLS))),
        messageDescriptor: (0, $lfFy6.messages).avocado
    },
    {
        id: 'baboon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5RzHY))),
        messageDescriptor: (0, $lfFy6.messages).baboon
    },
    {
        id: 'badger',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eA5k9))),
        messageDescriptor: (0, $lfFy6.messages).badger
    },
    {
        id: 'bat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dLHML))),
        messageDescriptor: (0, $lfFy6.messages).bat
    },
    {
        id: 'bear',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5QM3U))),
        messageDescriptor: (0, $lfFy6.messages).bear
    },
    {
        id: 'beaver',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1zbJy))),
        messageDescriptor: (0, $lfFy6.messages).beaver
    },
    {
        id: 'bee',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($absgL))),
        messageDescriptor: (0, $lfFy6.messages).bee
    },
    {
        id: 'bird',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($018bO))),
        messageDescriptor: (0, $lfFy6.messages).bird
    },
    {
        id: 'bison',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i9wU3))),
        messageDescriptor: (0, $lfFy6.messages).bison
    },
    {
        id: 'blobfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnUXX))),
        messageDescriptor: (0, $lfFy6.messages).blobfish
    },
    {
        id: 'blossom',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7BD8h))),
        messageDescriptor: (0, $lfFy6.messages).blossom
    },
    {
        id: 'blowfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ipNYr))),
        messageDescriptor: (0, $lfFy6.messages).blowfish
    },
    {
        id: 'blueberries',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5Fo99))),
        messageDescriptor: (0, $lfFy6.messages).blueberries
    },
    {
        id: 'boar',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($futbp))),
        messageDescriptor: (0, $lfFy6.messages).boar
    },
    {
        id: 'broccoli',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1tL0q))),
        messageDescriptor: (0, $lfFy6.messages).broccoli
    },
    {
        id: 'buffalo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i9wU3))),
        messageDescriptor: (0, $lfFy6.messages).buffalo
    },
    {
        id: 'bug',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gsqYV))),
        messageDescriptor: (0, $lfFy6.messages).bug
    },
    {
        id: 'bull',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7Za1I))),
        messageDescriptor: (0, $lfFy6.messages).bull
    },
    {
        id: 'bunny',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($zYoHs))),
        messageDescriptor: (0, $lfFy6.messages).bunny
    },
    {
        id: 'butterfly',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gsqYV))),
        messageDescriptor: (0, $lfFy6.messages).butterfly
    },
    {
        id: 'cactus',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aV0Ix))),
        messageDescriptor: (0, $lfFy6.messages).cactus
    },
    {
        id: 'camel',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7f8BP))),
        messageDescriptor: (0, $lfFy6.messages).camel
    },
    {
        id: 'candy',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($w2g3p))),
        messageDescriptor: (0, $lfFy6.messages).candy
    },
    {
        id: 'cantaloupe',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7y9m7))),
        messageDescriptor: (0, $lfFy6.messages).cantaloupe
    },
    {
        id: 'capsicum',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7pNkU))),
        messageDescriptor: (0, $lfFy6.messages).capsicum
    },
    {
        id: 'carrot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3saEQ))),
        messageDescriptor: (0, $lfFy6.messages).carrot
    },
    {
        id: 'cat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bBrvm))),
        messageDescriptor: (0, $lfFy6.messages).cat
    },
    {
        id: 'caterpiller',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2MJ1F))),
        messageDescriptor: (0, $lfFy6.messages).caterpiller
    },
    {
        id: 'chameleon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5fTd1))),
        messageDescriptor: (0, $lfFy6.messages).chameleon
    },
    {
        id: 'cherry',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($62PyO))),
        messageDescriptor: (0, $lfFy6.messages).cherry
    },
    {
        id: 'chili',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ct5mQ))),
        messageDescriptor: (0, $lfFy6.messages).chili
    },
    {
        id: 'chimp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kRP7t))),
        messageDescriptor: (0, $lfFy6.messages).chimp
    },
    {
        id: 'chimpanzee',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kRP7t))),
        messageDescriptor: (0, $lfFy6.messages).chimpanzee
    },
    {
        id: 'clover',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($geCWF))),
        messageDescriptor: (0, $lfFy6.messages).clover
    },
    {
        id: 'clownfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($Ox4am))),
        messageDescriptor: (0, $lfFy6.messages).clownfish
    },
    {
        id: 'cobra',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dGRYO))),
        messageDescriptor: (0, $lfFy6.messages).cobra
    },
    {
        id: 'coconut',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cA6yA))),
        messageDescriptor: (0, $lfFy6.messages).coconut
    },
    {
        id: 'cod',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnUXX))),
        messageDescriptor: (0, $lfFy6.messages).cod
    },
    {
        id: 'cookie',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gE9fP))),
        messageDescriptor: (0, $lfFy6.messages).cookie
    },
    {
        id: 'corn',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6Cmrb))),
        messageDescriptor: (0, $lfFy6.messages).corn
    },
    {
        id: 'cow',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7Za1I))),
        messageDescriptor: (0, $lfFy6.messages).cow
    },
    {
        id: 'crab',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kgPFA))),
        messageDescriptor: (0, $lfFy6.messages).crab
    },
    {
        id: 'crocodile',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2hRuV))),
        messageDescriptor: (0, $lfFy6.messages).crocodile
    },
    {
        id: 'deer',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8H1nG))),
        messageDescriptor: (0, $lfFy6.messages).deer
    },
    {
        id: 'dinosaur',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jfdMm))),
        messageDescriptor: (0, $lfFy6.messages).dinosaur
    },
    {
        id: 'dodo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jAnMk))),
        messageDescriptor: (0, $lfFy6.messages).dodo
    },
    {
        id: 'dog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kiped))),
        messageDescriptor: (0, $lfFy6.messages).dog
    },
    {
        id: 'dolphin',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ijRK6))),
        messageDescriptor: (0, $lfFy6.messages).dolphin
    },
    {
        id: 'donut',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hQTrZ))),
        messageDescriptor: (0, $lfFy6.messages).donut
    },
    {
        id: 'dragon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3ussC))),
        messageDescriptor: (0, $lfFy6.messages).dragon
    },
    {
        id: 'duck',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bfQlR))),
        messageDescriptor: (0, $lfFy6.messages).duck
    },
    {
        id: 'elephant',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($g2zNl))),
        messageDescriptor: (0, $lfFy6.messages).elephant
    },
    {
        id: 'elk',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8H1nG))),
        messageDescriptor: (0, $lfFy6.messages).elk
    },
    {
        id: 'fish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnUXX))),
        messageDescriptor: (0, $lfFy6.messages).fish
    },
    {
        id: 'flamingo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ldCFU))),
        messageDescriptor: (0, $lfFy6.messages).flamingo
    },
    {
        id: 'fox',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gcvuo))),
        messageDescriptor: (0, $lfFy6.messages).fox
    },
    {
        id: 'frog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3aulr))),
        messageDescriptor: (0, $lfFy6.messages).frog
    },
    {
        id: 'gecko',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5fTd1))),
        messageDescriptor: (0, $lfFy6.messages).gecko
    },
    {
        id: 'giraffe',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jj7JF))),
        messageDescriptor: (0, $lfFy6.messages).giraffe
    },
    {
        id: 'gorilla',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gFh8H))),
        messageDescriptor: (0, $lfFy6.messages).gorilla
    },
    {
        id: 'grape',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ib1i9))),
        messageDescriptor: (0, $lfFy6.messages).grape
    },
    {
        id: 'hammerhead',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eMHgQ))),
        messageDescriptor: (0, $lfFy6.messages).hammerhead
    },
    {
        id: 'hedgehog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7vWf2))),
        messageDescriptor: (0, $lfFy6.messages).hedgehog
    },
    {
        id: 'hippo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($MAw5A))),
        messageDescriptor: (0, $lfFy6.messages).hippo
    },
    {
        id: 'kangaroo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4R6fR))),
        messageDescriptor: (0, $lfFy6.messages).kangaroo
    },
    {
        id: 'kitten',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bBrvm))),
        messageDescriptor: (0, $lfFy6.messages).kitten
    },
    {
        id: 'kiwi',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3G8sv))),
        messageDescriptor: (0, $lfFy6.messages).kiwi
    },
    {
        id: 'koala',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5L3ZL))),
        messageDescriptor: (0, $lfFy6.messages).koala
    },
    {
        id: 'lemon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1tIXy))),
        messageDescriptor: (0, $lfFy6.messages).lemon
    },
    {
        id: 'leopard',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($62BuW))),
        messageDescriptor: (0, $lfFy6.messages).leopard
    },
    {
        id: 'lettuce',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gIr5o))),
        messageDescriptor: (0, $lfFy6.messages).lettuce
    },
    {
        id: 'lion',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jMi9Z))),
        messageDescriptor: (0, $lfFy6.messages).lion
    },
    {
        id: 'lizard',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5fTd1))),
        messageDescriptor: (0, $lfFy6.messages).lizard
    },
    {
        id: 'llama',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($70IXo))),
        messageDescriptor: (0, $lfFy6.messages).llama
    },
    {
        id: 'lobster',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($k45BN))),
        messageDescriptor: (0, $lfFy6.messages).lobster
    },
    {
        id: 'macaque',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kRP7t))),
        messageDescriptor: (0, $lfFy6.messages).macaque
    },
    {
        id: 'mango',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5t7IX))),
        messageDescriptor: (0, $lfFy6.messages).mango
    },
    {
        id: 'melon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($76eQq))),
        messageDescriptor: (0, $lfFy6.messages).melon
    },
    {
        id: 'millipede',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2MJ1F))),
        messageDescriptor: (0, $lfFy6.messages).millipede
    },
    {
        id: 'monkey',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kRP7t))),
        messageDescriptor: (0, $lfFy6.messages).monkey
    },
    {
        id: 'mouse',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dLJHp))),
        messageDescriptor: (0, $lfFy6.messages).mouse
    },
    {
        id: 'octopus',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($MvguA))),
        messageDescriptor: (0, $lfFy6.messages).octopus
    },
    {
        id: 'olive',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i2wVj))),
        messageDescriptor: (0, $lfFy6.messages).olive
    },
    {
        id: 'orange',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bqNy3))),
        messageDescriptor: (0, $lfFy6.messages).orange
    },
    {
        id: 'orangutan',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5RzHY))),
        messageDescriptor: (0, $lfFy6.messages).orangutan
    },
    {
        id: 'otter',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jN43s))),
        messageDescriptor: (0, $lfFy6.messages).otter
    },
    {
        id: 'owl',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($018bO))),
        messageDescriptor: (0, $lfFy6.messages).owl
    },
    {
        id: 'ox',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c3T8r))),
        messageDescriptor: (0, $lfFy6.messages).ox
    },
    {
        id: 'oyster',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($h0256))),
        messageDescriptor: (0, $lfFy6.messages).oyster
    },
    {
        id: 'panda',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8O3eM))),
        messageDescriptor: (0, $lfFy6.messages).panda
    },
    {
        id: 'parrot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8BcsQ))),
        messageDescriptor: (0, $lfFy6.messages).parrot
    },
    {
        id: 'peacock',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ctuOo))),
        messageDescriptor: (0, $lfFy6.messages).peacock
    },
    {
        id: 'pear',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9wms3))),
        messageDescriptor: (0, $lfFy6.messages).pear
    },
    {
        id: 'penguin',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1j7TY))),
        messageDescriptor: (0, $lfFy6.messages).penguin
    },
    {
        id: 'pig',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4ux8O))),
        messageDescriptor: (0, $lfFy6.messages).pig
    },
    {
        id: 'pineapple',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($44Sb4))),
        messageDescriptor: (0, $lfFy6.messages).pineapple
    },
    {
        id: 'poodle',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dQMZo))),
        messageDescriptor: (0, $lfFy6.messages).poodle
    },
    {
        id: 'puppy',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kiped))),
        messageDescriptor: (0, $lfFy6.messages).puppy
    },
    {
        id: 'python',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dGRYO))),
        messageDescriptor: (0, $lfFy6.messages).python
    },
    {
        id: 'rabbit',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($zYoHs))),
        messageDescriptor: (0, $lfFy6.messages).rabbit
    },
    {
        id: 'raccoon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($04PGh))),
        messageDescriptor: (0, $lfFy6.messages).raccoon
    },
    {
        id: 'rat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dLJHp))),
        messageDescriptor: (0, $lfFy6.messages).rat
    },
    {
        id: 'rhino',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ddSO1))),
        messageDescriptor: (0, $lfFy6.messages).rhino
    },
    {
        id: 'robot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ivVMv))),
        messageDescriptor: (0, $lfFy6.messages).robot
    },
    {
        id: 'rose',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eJnd2))),
        messageDescriptor: (0, $lfFy6.messages).rose
    },
    {
        id: 'seal',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($98ut7))),
        messageDescriptor: (0, $lfFy6.messages).seal
    },
    {
        id: 'seedling',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9q1Vk))),
        messageDescriptor: (0, $lfFy6.messages).seedling
    },
    {
        id: 'shark',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eMHgQ))),
        messageDescriptor: (0, $lfFy6.messages).shark
    },
    {
        id: 'shrimp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3LKHJ))),
        messageDescriptor: (0, $lfFy6.messages).shrimp
    },
    {
        id: 'skunk',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3ZCOi))),
        messageDescriptor: (0, $lfFy6.messages).skunk
    },
    {
        id: 'sloth',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5xoX8))),
        messageDescriptor: (0, $lfFy6.messages).sloth
    },
    {
        id: 'snail',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5qhol))),
        messageDescriptor: (0, $lfFy6.messages).snail
    },
    {
        id: 'snake',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dGRYO))),
        messageDescriptor: (0, $lfFy6.messages).snake
    },
    {
        id: 'snowman',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6dhVt))),
        messageDescriptor: (0, $lfFy6.messages).snowman
    },
    {
        id: 'squid',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ighEF))),
        messageDescriptor: (0, $lfFy6.messages).squid
    },
    {
        id: 'squirrel',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jiyfa))),
        messageDescriptor: (0, $lfFy6.messages).squirrel
    },
    {
        id: 'strawberry',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aRWto))),
        messageDescriptor: (0, $lfFy6.messages).strawberry
    },
    {
        id: 'sunfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($Ox4am))),
        messageDescriptor: (0, $lfFy6.messages).sunfish
    },
    {
        id: 'sunflower',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3VNps))),
        messageDescriptor: (0, $lfFy6.messages).sunflower
    },
    {
        id: 'tiger',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($62BuW))),
        messageDescriptor: (0, $lfFy6.messages).tiger
    },
    {
        id: 'tomato',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($54a3y))),
        messageDescriptor: (0, $lfFy6.messages).tomato
    },
    {
        id: 'tortoise',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5gEBh))),
        messageDescriptor: (0, $lfFy6.messages).tortoise
    },
    {
        id: 'tree',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cjnzF))),
        messageDescriptor: (0, $lfFy6.messages).tree
    },
    {
        id: 'trex',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($faukZ))),
        messageDescriptor: (0, $lfFy6.messages).trex
    },
    {
        id: 'trout',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnUXX))),
        messageDescriptor: (0, $lfFy6.messages).trout
    },
    {
        id: 'turkey',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hembw))),
        messageDescriptor: (0, $lfFy6.messages).turkey
    },
    {
        id: 'turtle',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5gEBh))),
        messageDescriptor: (0, $lfFy6.messages).turtle
    },
    {
        id: 'wasp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($absgL))),
        messageDescriptor: (0, $lfFy6.messages).wasp
    },
    {
        id: 'watermelon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($76eQq))),
        messageDescriptor: (0, $lfFy6.messages).watermelon
    },
    {
        id: 'whale',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($68Yx0))),
        messageDescriptor: (0, $lfFy6.messages).whale
    },
    {
        id: 'wolf',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l08I5))),
        messageDescriptor: (0, $lfFy6.messages).wolf
    }
];
module.exports["ANONYMOUS_ASSETS"] = $40b74b738da6af36$export$4522d3d70312bbdc;

});

parcelRegister("lfFy6", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $11f365f4e13bb9e0$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    alligator: {
        id: "platform.anonymous-asset-name.alligator",
        defaultMessage: "Anonymous Alligator"
    },
    alpaca: {
        id: "platform.anonymous-asset-name.alpaca",
        defaultMessage: "Anonymous Alpaca"
    },
    ape: {
        id: "platform.anonymous-asset-name.ape",
        defaultMessage: "Anonymous Ape"
    },
    apple: {
        id: "platform.anonymous-asset-name.apple",
        defaultMessage: "Anonymous Apple"
    },
    avocado: {
        id: "platform.anonymous-asset-name.avocado",
        defaultMessage: "Anonymous Avocado"
    },
    baboon: {
        id: "platform.anonymous-asset-name.baboon",
        defaultMessage: "Anonymous Baboon"
    },
    badger: {
        id: "platform.anonymous-asset-name.badger",
        defaultMessage: "Anonymous Badger"
    },
    bat: {
        id: "platform.anonymous-asset-name.bat",
        defaultMessage: "Anonymous Bat"
    },
    bear: {
        id: "platform.anonymous-asset-name.bear",
        defaultMessage: "Anonymous Bear"
    },
    beaver: {
        id: "platform.anonymous-asset-name.beaver",
        defaultMessage: "Anonymous Beaver"
    },
    bee: {
        id: "platform.anonymous-asset-name.bee",
        defaultMessage: "Anonymous Bee"
    },
    bird: {
        id: "platform.anonymous-asset-name.bird",
        defaultMessage: "Anonymous Bird"
    },
    bison: {
        id: "platform.anonymous-asset-name.bison",
        defaultMessage: "Anonymous Bison"
    },
    blobfish: {
        id: "platform.anonymous-asset-name.blobfish",
        defaultMessage: "Anonymous Blobfish"
    },
    blossom: {
        id: "platform.anonymous-asset-name.blossom",
        defaultMessage: "Anonymous Blossom"
    },
    blowfish: {
        id: "platform.anonymous-asset-name.blowfish",
        defaultMessage: "Anonymous Blowfish"
    },
    blueberries: {
        id: "platform.anonymous-asset-name.blueberries",
        defaultMessage: "Anonymous Blueberries"
    },
    boar: {
        id: "platform.anonymous-asset-name.boar",
        defaultMessage: "Anonymous Boar"
    },
    broccoli: {
        id: "platform.anonymous-asset-name.broccoli",
        defaultMessage: "Anonymous Broccoli"
    },
    buffalo: {
        id: "platform.anonymous-asset-name.buffalo",
        defaultMessage: "Anonymous Buffalo"
    },
    bug: {
        id: "platform.anonymous-asset-name.bug",
        defaultMessage: "Anonymous Bug"
    },
    bull: {
        id: "platform.anonymous-asset-name.bull",
        defaultMessage: "Anonymous Bull"
    },
    bunny: {
        id: "platform.anonymous-asset-name.bunny",
        defaultMessage: "Anonymous Bunny"
    },
    butterfly: {
        id: "platform.anonymous-asset-name.butterfly",
        defaultMessage: "Anonymous Butterfly"
    },
    cactus: {
        id: "platform.anonymous-asset-name.cactus",
        defaultMessage: "Anonymous Cactus"
    },
    camel: {
        id: "platform.anonymous-asset-name.camel",
        defaultMessage: "Anonymous Camel"
    },
    candy: {
        id: "platform.anonymous-asset-name.candy",
        defaultMessage: "Anonymous Candy"
    },
    cantaloupe: {
        id: "platform.anonymous-asset-name.cantaloupe",
        defaultMessage: "Anonymous Cantaloupe"
    },
    capsicum: {
        id: "platform.anonymous-asset-name.capsicum",
        defaultMessage: "Anonymous Capsicum"
    },
    carrot: {
        id: "platform.anonymous-asset-name.carrot",
        defaultMessage: "Anonymous Carrot"
    },
    cat: {
        id: "platform.anonymous-asset-name.cat",
        defaultMessage: "Anonymous Cat"
    },
    caterpiller: {
        id: "platform.anonymous-asset-name.caterpiller",
        defaultMessage: "Anonymous Caterpiller"
    },
    chameleon: {
        id: "platform.anonymous-asset-name.chameleon",
        defaultMessage: "Anonymous Chameleon"
    },
    cherry: {
        id: "platform.anonymous-asset-name.cherry",
        defaultMessage: "Anonymous Cherry"
    },
    chili: {
        id: "platform.anonymous-asset-name.chili",
        defaultMessage: "Anonymous Chili"
    },
    chimp: {
        id: "platform.anonymous-asset-name.chimp",
        defaultMessage: "Anonymous Chimp"
    },
    chimpanzee: {
        id: "platform.anonymous-asset-name.chimpanzee",
        defaultMessage: "Anonymous Chimpanzee"
    },
    clover: {
        id: "platform.anonymous-asset-name.clover",
        defaultMessage: "Anonymous Clover"
    },
    clownfish: {
        id: "platform.anonymous-asset-name.clownfish",
        defaultMessage: "Anonymous Clownfish"
    },
    cobra: {
        id: "platform.anonymous-asset-name.cobra",
        defaultMessage: "Anonymous Cobra"
    },
    coconut: {
        id: "platform.anonymous-asset-name.coconut",
        defaultMessage: "Anonymous Coconut"
    },
    cod: {
        id: "platform.anonymous-asset-name.cod",
        defaultMessage: "Anonymous Cod"
    },
    cookie: {
        id: "platform.anonymous-asset-name.cookie",
        defaultMessage: "Anonymous Cookie"
    },
    corn: {
        id: "platform.anonymous-asset-name.corn",
        defaultMessage: "Anonymous Corn"
    },
    cow: {
        id: "platform.anonymous-asset-name.cow",
        defaultMessage: "Anonymous Cow"
    },
    crab: {
        id: "platform.anonymous-asset-name.crab",
        defaultMessage: "Anonymous Crab"
    },
    crocodile: {
        id: "platform.anonymous-asset-name.crocodile",
        defaultMessage: "Anonymous Crocodile"
    },
    deer: {
        id: "platform.anonymous-asset-name.deer",
        defaultMessage: "Anonymous Deer"
    },
    dinosaur: {
        id: "platform.anonymous-asset-name.dinosaur",
        defaultMessage: "Anonymous Dinosaur"
    },
    dodo: {
        id: "platform.anonymous-asset-name.dodo",
        defaultMessage: "Anonymous Dodo"
    },
    dog: {
        id: "platform.anonymous-asset-name.dog",
        defaultMessage: "Anonymous Dog"
    },
    dolphin: {
        id: "platform.anonymous-asset-name.dolphin",
        defaultMessage: "Anonymous Dolphin"
    },
    donut: {
        id: "platform.anonymous-asset-name.donut",
        defaultMessage: "Anonymous Donut"
    },
    dragon: {
        id: "platform.anonymous-asset-name.dragon",
        defaultMessage: "Anonymous Dragon"
    },
    duck: {
        id: "platform.anonymous-asset-name.duck",
        defaultMessage: "Anonymous Duck"
    },
    elephant: {
        id: "platform.anonymous-asset-name.elephant",
        defaultMessage: "Anonymous Elephant"
    },
    elk: {
        id: "platform.anonymous-asset-name.elk",
        defaultMessage: "Anonymous Elk"
    },
    fish: {
        id: "platform.anonymous-asset-name.fish",
        defaultMessage: "Anonymous Fish"
    },
    flamingo: {
        id: "platform.anonymous-asset-name.flamingo",
        defaultMessage: "Anonymous Flamingo"
    },
    fox: {
        id: "platform.anonymous-asset-name.fox",
        defaultMessage: "Anonymous Fox"
    },
    frog: {
        id: "platform.anonymous-asset-name.frog",
        defaultMessage: "Anonymous Frog"
    },
    gecko: {
        id: "platform.anonymous-asset-name.gecko",
        defaultMessage: "Anonymous Gecko"
    },
    giraffe: {
        id: "platform.anonymous-asset-name.giraffe",
        defaultMessage: "Anonymous Giraffe"
    },
    gorilla: {
        id: "platform.anonymous-asset-name.gorilla",
        defaultMessage: "Anonymous Gorilla"
    },
    grape: {
        id: "platform.anonymous-asset-name.grape",
        defaultMessage: "Anonymous Grape"
    },
    hammerhead: {
        id: "platform.anonymous-asset-name.hammerhead",
        defaultMessage: "Anonymous Hammerhead"
    },
    hedgehog: {
        id: "platform.anonymous-asset-name.hedgehog",
        defaultMessage: "Anonymous Hedgehog"
    },
    hippo: {
        id: "platform.anonymous-asset-name.hippo",
        defaultMessage: "Anonymous Hippo"
    },
    kangaroo: {
        id: "platform.anonymous-asset-name.kangaroo",
        defaultMessage: "Anonymous Kangaroo"
    },
    kitten: {
        id: "platform.anonymous-asset-name.kitten",
        defaultMessage: "Anonymous Kitten"
    },
    kiwi: {
        id: "platform.anonymous-asset-name.kiwi",
        defaultMessage: "Anonymous Kiwi"
    },
    koala: {
        id: "platform.anonymous-asset-name.koala",
        defaultMessage: "Anonymous Koala"
    },
    lemon: {
        id: "platform.anonymous-asset-name.lemon",
        defaultMessage: "Anonymous Lemon"
    },
    leopard: {
        id: "platform.anonymous-asset-name.leopard",
        defaultMessage: "Anonymous Leopard"
    },
    lettuce: {
        id: "platform.anonymous-asset-name.lettuce",
        defaultMessage: "Anonymous Lettuce"
    },
    lion: {
        id: "platform.anonymous-asset-name.lion",
        defaultMessage: "Anonymous Lion"
    },
    lizard: {
        id: "platform.anonymous-asset-name.lizard",
        defaultMessage: "Anonymous Lizard"
    },
    llama: {
        id: "platform.anonymous-asset-name.llama",
        defaultMessage: "Anonymous Llama"
    },
    lobster: {
        id: "platform.anonymous-asset-name.lobster",
        defaultMessage: "Anonymous Lobster"
    },
    macaque: {
        id: "platform.anonymous-asset-name.macaque",
        defaultMessage: "Anonymous Macaque"
    },
    mango: {
        id: "platform.anonymous-asset-name.mango",
        defaultMessage: "Anonymous Mango"
    },
    melon: {
        id: "platform.anonymous-asset-name.melon",
        defaultMessage: "Anonymous Melon"
    },
    millipede: {
        id: "platform.anonymous-asset-name.millipede",
        defaultMessage: "Anonymous Millipede"
    },
    monkey: {
        id: "platform.anonymous-asset-name.monkey",
        defaultMessage: "Anonymous Monkey"
    },
    mouse: {
        id: "platform.anonymous-asset-name.mouse",
        defaultMessage: "Anonymous Mouse"
    },
    octopus: {
        id: "platform.anonymous-asset-name.octopus",
        defaultMessage: "Anonymous Octopus"
    },
    olive: {
        id: "platform.anonymous-asset-name.olive",
        defaultMessage: "Anonymous Olive"
    },
    orange: {
        id: "platform.anonymous-asset-name.orange",
        defaultMessage: "Anonymous Orange"
    },
    orangutan: {
        id: "platform.anonymous-asset-name.orangutan",
        defaultMessage: "Anonymous Orangutan"
    },
    otter: {
        id: "platform.anonymous-asset-name.otter",
        defaultMessage: "Anonymous Otter"
    },
    owl: {
        id: "platform.anonymous-asset-name.owl",
        defaultMessage: "Anonymous Owl"
    },
    ox: {
        id: "platform.anonymous-asset-name.ox",
        defaultMessage: "Anonymous Ox"
    },
    oyster: {
        id: "platform.anonymous-asset-name.oyster",
        defaultMessage: "Anonymous Oyster"
    },
    panda: {
        id: "platform.anonymous-asset-name.panda",
        defaultMessage: "Anonymous Panda"
    },
    parrot: {
        id: "platform.anonymous-asset-name.parrot",
        defaultMessage: "Anonymous Parrot"
    },
    peacock: {
        id: "platform.anonymous-asset-name.peacock",
        defaultMessage: "Anonymous Peacock"
    },
    pear: {
        id: "platform.anonymous-asset-name.pear",
        defaultMessage: "Anonymous Pear"
    },
    penguin: {
        id: "platform.anonymous-asset-name.penguin",
        defaultMessage: "Anonymous Penguin"
    },
    pig: {
        id: "platform.anonymous-asset-name.pig",
        defaultMessage: "Anonymous Pig"
    },
    pineapple: {
        id: "platform.anonymous-asset-name.pineapple",
        defaultMessage: "Anonymous Pineapple"
    },
    poodle: {
        id: "platform.anonymous-asset-name.poodle",
        defaultMessage: "Anonymous Poodle"
    },
    puppy: {
        id: "platform.anonymous-asset-name.puppy",
        defaultMessage: "Anonymous Puppy"
    },
    python: {
        id: "platform.anonymous-asset-name.python",
        defaultMessage: "Anonymous Python"
    },
    rabbit: {
        id: "platform.anonymous-asset-name.rabbit",
        defaultMessage: "Anonymous Rabbit"
    },
    raccoon: {
        id: "platform.anonymous-asset-name.raccoon",
        defaultMessage: "Anonymous Raccoon"
    },
    rat: {
        id: "platform.anonymous-asset-name.rat",
        defaultMessage: "Anonymous Rat"
    },
    rhino: {
        id: "platform.anonymous-asset-name.rhino",
        defaultMessage: "Anonymous Rhino"
    },
    robot: {
        id: "platform.anonymous-asset-name.robot",
        defaultMessage: "Anonymous Robot"
    },
    rose: {
        id: "platform.anonymous-asset-name.rose",
        defaultMessage: "Anonymous Rose"
    },
    seal: {
        id: "platform.anonymous-asset-name.seal",
        defaultMessage: "Anonymous Seal"
    },
    seedling: {
        id: "platform.anonymous-asset-name.seedling",
        defaultMessage: "Anonymous Seedling"
    },
    shark: {
        id: "platform.anonymous-asset-name.shark",
        defaultMessage: "Anonymous Shark"
    },
    shrimp: {
        id: "platform.anonymous-asset-name.shrimp",
        defaultMessage: "Anonymous Shrimp"
    },
    skunk: {
        id: "platform.anonymous-asset-name.skunk",
        defaultMessage: "Anonymous Skunk"
    },
    sloth: {
        id: "platform.anonymous-asset-name.sloth",
        defaultMessage: "Anonymous Sloth"
    },
    snail: {
        id: "platform.anonymous-asset-name.snail",
        defaultMessage: "Anonymous Snail"
    },
    snake: {
        id: "platform.anonymous-asset-name.snake",
        defaultMessage: "Anonymous Snake"
    },
    snowman: {
        id: "platform.anonymous-asset-name.snowman",
        defaultMessage: "Anonymous Snowman"
    },
    squid: {
        id: "platform.anonymous-asset-name.squid",
        defaultMessage: "Anonymous Squid"
    },
    squirrel: {
        id: "platform.anonymous-asset-name.squirrel",
        defaultMessage: "Anonymous Squirrel"
    },
    strawberry: {
        id: "platform.anonymous-asset-name.strawberry",
        defaultMessage: "Anonymous Strawberry"
    },
    sunfish: {
        id: "platform.anonymous-asset-name.sunfish",
        defaultMessage: "Anonymous Sunfish"
    },
    sunflower: {
        id: "platform.anonymous-asset-name.sunflower",
        defaultMessage: "Anonymous Sunflower"
    },
    tiger: {
        id: "platform.anonymous-asset-name.tiger",
        defaultMessage: "Anonymous Tiger"
    },
    tomato: {
        id: "platform.anonymous-asset-name.tomato",
        defaultMessage: "Anonymous Tomato"
    },
    tortoise: {
        id: "platform.anonymous-asset-name.tortoise",
        defaultMessage: "Anonymous Tortoise"
    },
    tree: {
        id: "platform.anonymous-asset-name.tree",
        defaultMessage: "Anonymous Tree"
    },
    trex: {
        id: "platform.anonymous-asset-name.trex",
        defaultMessage: "Anonymous T-rex"
    },
    trout: {
        id: "platform.anonymous-asset-name.trout",
        defaultMessage: "Anonymous Trout"
    },
    turkey: {
        id: "platform.anonymous-asset-name.turkey",
        defaultMessage: "Anonymous Turkey"
    },
    turtle: {
        id: "platform.anonymous-asset-name.turtle",
        defaultMessage: "Anonymous Turtle"
    },
    wasp: {
        id: "platform.anonymous-asset-name.wasp",
        defaultMessage: "Anonymous Wasp"
    },
    watermelon: {
        id: "platform.anonymous-asset-name.watermelon",
        defaultMessage: "Anonymous Watermelon"
    },
    whale: {
        id: "platform.anonymous-asset-name.whale",
        defaultMessage: "Anonymous Whale"
    },
    wolf: {
        id: "platform.anonymous-asset-name.wolf",
        defaultMessage: "Anonymous Wolf"
    }
});
module.exports["messages"] = $11f365f4e13bb9e0$export$defe85febe8b728c;

});

parcelRegister("45p5c", function(module, exports) {
module.exports = new URL("apple.ee886279.svg", import.meta.url).toString();

});

parcelRegister("66aLS", function(module, exports) {
module.exports = new URL("avocado.8855629b.svg", import.meta.url).toString();

});

parcelRegister("eA5k9", function(module, exports) {
module.exports = new URL("badger.0fb3ff8d.svg", import.meta.url).toString();

});

parcelRegister("dLHML", function(module, exports) {
module.exports = new URL("bat.3a3e8172.svg", import.meta.url).toString();

});

parcelRegister("5QM3U", function(module, exports) {
module.exports = new URL("bear.6250dade.svg", import.meta.url).toString();

});

parcelRegister("1zbJy", function(module, exports) {
module.exports = new URL("beaver.72239cbc.svg", import.meta.url).toString();

});

parcelRegister("absgL", function(module, exports) {
module.exports = new URL("bee.1d8bfe50.svg", import.meta.url).toString();

});

parcelRegister("i9wU3", function(module, exports) {
module.exports = new URL("bison.4fe77735.svg", import.meta.url).toString();

});

parcelRegister("7BD8h", function(module, exports) {
module.exports = new URL("blossom.90b2a1c3.svg", import.meta.url).toString();

});

parcelRegister("ipNYr", function(module, exports) {
module.exports = new URL("blowfish.8afad7f1.svg", import.meta.url).toString();

});

parcelRegister("5Fo99", function(module, exports) {
module.exports = new URL("blueberries.688d225d.svg", import.meta.url).toString();

});

parcelRegister("futbp", function(module, exports) {
module.exports = new URL("boar.15310caf.svg", import.meta.url).toString();

});

parcelRegister("1tL0q", function(module, exports) {
module.exports = new URL("broccoli.fa9fd55e.svg", import.meta.url).toString();

});

parcelRegister("gsqYV", function(module, exports) {
module.exports = new URL("butterfly.f41d19d4.svg", import.meta.url).toString();

});

parcelRegister("aV0Ix", function(module, exports) {
module.exports = new URL("cactus.0c5c265c.svg", import.meta.url).toString();

});

parcelRegister("7f8BP", function(module, exports) {
module.exports = new URL("camel.6111d481.svg", import.meta.url).toString();

});

parcelRegister("w2g3p", function(module, exports) {
module.exports = new URL("candy.ffd5e59f.svg", import.meta.url).toString();

});

parcelRegister("7pNkU", function(module, exports) {
module.exports = new URL("capsicum.30f76734.svg", import.meta.url).toString();

});

parcelRegister("3saEQ", function(module, exports) {
module.exports = new URL("carrot.6193f6d7.svg", import.meta.url).toString();

});

parcelRegister("bBrvm", function(module, exports) {
module.exports = new URL("cat.154e1595.svg", import.meta.url).toString();

});

parcelRegister("2MJ1F", function(module, exports) {
module.exports = new URL("caterpiller.1b6fd239.svg", import.meta.url).toString();

});

parcelRegister("62PyO", function(module, exports) {
module.exports = new URL("cherry.087938da.svg", import.meta.url).toString();

});

parcelRegister("ct5mQ", function(module, exports) {
module.exports = new URL("chili.27401d1a.svg", import.meta.url).toString();

});

parcelRegister("geCWF", function(module, exports) {
module.exports = new URL("clover.296ea840.svg", import.meta.url).toString();

});

parcelRegister("cA6yA", function(module, exports) {
module.exports = new URL("coconut.69480f00.svg", import.meta.url).toString();

});

parcelRegister("gE9fP", function(module, exports) {
module.exports = new URL("cookie.099bb841.svg", import.meta.url).toString();

});

parcelRegister("6Cmrb", function(module, exports) {
module.exports = new URL("corn.f527dc60.svg", import.meta.url).toString();

});

parcelRegister("7Za1I", function(module, exports) {
module.exports = new URL("cow.e41482e6.svg", import.meta.url).toString();

});

parcelRegister("kgPFA", function(module, exports) {
module.exports = new URL("crab.39812367.svg", import.meta.url).toString();

});

parcelRegister("2hRuV", function(module, exports) {
module.exports = new URL("crocodile.221fa99c.svg", import.meta.url).toString();

});

parcelRegister("8H1nG", function(module, exports) {
module.exports = new URL("deer.3662e324.svg", import.meta.url).toString();

});

parcelRegister("jfdMm", function(module, exports) {
module.exports = new URL("dinosaur.e5c6efb5.svg", import.meta.url).toString();

});

parcelRegister("jAnMk", function(module, exports) {
module.exports = new URL("dodo.a7114237.svg", import.meta.url).toString();

});

parcelRegister("kiped", function(module, exports) {
module.exports = new URL("dog.6630bd37.svg", import.meta.url).toString();

});

parcelRegister("ijRK6", function(module, exports) {
module.exports = new URL("dolphin.3052ec02.svg", import.meta.url).toString();

});

parcelRegister("hQTrZ", function(module, exports) {
module.exports = new URL("donut.e4649522.svg", import.meta.url).toString();

});

parcelRegister("3ussC", function(module, exports) {
module.exports = new URL("dragon.4b6d8278.svg", import.meta.url).toString();

});

parcelRegister("bfQlR", function(module, exports) {
module.exports = new URL("duck.e8819dfa.svg", import.meta.url).toString();

});

parcelRegister("g2zNl", function(module, exports) {
module.exports = new URL("elephant.f64545b1.svg", import.meta.url).toString();

});

parcelRegister("dnUXX", function(module, exports) {
module.exports = new URL("fish.91063cf4.svg", import.meta.url).toString();

});

parcelRegister("ldCFU", function(module, exports) {
module.exports = new URL("flamingo.2d59f884.svg", import.meta.url).toString();

});

parcelRegister("gcvuo", function(module, exports) {
module.exports = new URL("fox.c1068dfa.svg", import.meta.url).toString();

});

parcelRegister("3aulr", function(module, exports) {
module.exports = new URL("frog.4c69f05a.svg", import.meta.url).toString();

});

parcelRegister("jj7JF", function(module, exports) {
module.exports = new URL("giraffe.65216e18.svg", import.meta.url).toString();

});

parcelRegister("gFh8H", function(module, exports) {
module.exports = new URL("gorilla.51f05093.svg", import.meta.url).toString();

});

parcelRegister("ib1i9", function(module, exports) {
module.exports = new URL("grapes.6a50728f.svg", import.meta.url).toString();

});

parcelRegister("7vWf2", function(module, exports) {
module.exports = new URL("hedgehog.4cc9668b.svg", import.meta.url).toString();

});

parcelRegister("MAw5A", function(module, exports) {
module.exports = new URL("hippo.81684e99.svg", import.meta.url).toString();

});

parcelRegister("4R6fR", function(module, exports) {
module.exports = new URL("kangaroo.099f9dd4.svg", import.meta.url).toString();

});

parcelRegister("3G8sv", function(module, exports) {
module.exports = new URL("kiwi.13ce1a05.svg", import.meta.url).toString();

});

parcelRegister("5L3ZL", function(module, exports) {
module.exports = new URL("koala.730a01eb.svg", import.meta.url).toString();

});

parcelRegister("1tIXy", function(module, exports) {
module.exports = new URL("lemon.7d7dfe19.svg", import.meta.url).toString();

});

parcelRegister("gIr5o", function(module, exports) {
module.exports = new URL("lettuce.39b86ec6.svg", import.meta.url).toString();

});

parcelRegister("jMi9Z", function(module, exports) {
module.exports = new URL("lion.191125b1.svg", import.meta.url).toString();

});

parcelRegister("5fTd1", function(module, exports) {
module.exports = new URL("lizard.de3c3103.svg", import.meta.url).toString();

});

parcelRegister("70IXo", function(module, exports) {
module.exports = new URL("llama.d767d641.svg", import.meta.url).toString();

});

parcelRegister("k45BN", function(module, exports) {
module.exports = new URL("lobster.2b4a4d94.svg", import.meta.url).toString();

});

parcelRegister("5t7IX", function(module, exports) {
module.exports = new URL("mango.6b9252cb.svg", import.meta.url).toString();

});

parcelRegister("7y9m7", function(module, exports) {
module.exports = new URL("melon.9c97f1e1.svg", import.meta.url).toString();

});

parcelRegister("kRP7t", function(module, exports) {
module.exports = new URL("monkey.423f2177.svg", import.meta.url).toString();

});

parcelRegister("dLJHp", function(module, exports) {
module.exports = new URL("mouse.3d0aefe8.svg", import.meta.url).toString();

});

parcelRegister("MvguA", function(module, exports) {
module.exports = new URL("octopus.2c0d1056.svg", import.meta.url).toString();

});

parcelRegister("i2wVj", function(module, exports) {
module.exports = new URL("olive.3e3e2c53.svg", import.meta.url).toString();

});

parcelRegister("bqNy3", function(module, exports) {
module.exports = new URL("orange.ed5e97f9.svg", import.meta.url).toString();

});

parcelRegister("5RzHY", function(module, exports) {
module.exports = new URL("orangutan.9fa13362.svg", import.meta.url).toString();

});

parcelRegister("jN43s", function(module, exports) {
module.exports = new URL("otter.1b9e17fe.svg", import.meta.url).toString();

});

parcelRegister("018bO", function(module, exports) {
module.exports = new URL("owl.13d3c4d9.svg", import.meta.url).toString();

});

parcelRegister("c3T8r", function(module, exports) {
module.exports = new URL("ox.0ed06fd3.svg", import.meta.url).toString();

});

parcelRegister("h0256", function(module, exports) {
module.exports = new URL("oyster.ad23795d.svg", import.meta.url).toString();

});

parcelRegister("8O3eM", function(module, exports) {
module.exports = new URL("panda.0b0047af.svg", import.meta.url).toString();

});

parcelRegister("8BcsQ", function(module, exports) {
module.exports = new URL("parrot.6fd92eec.svg", import.meta.url).toString();

});

parcelRegister("ctuOo", function(module, exports) {
module.exports = new URL("peacock.80ac60a6.svg", import.meta.url).toString();

});

parcelRegister("9wms3", function(module, exports) {
module.exports = new URL("pear.c8d37fb0.svg", import.meta.url).toString();

});

parcelRegister("1j7TY", function(module, exports) {
module.exports = new URL("penguin.6577e559.svg", import.meta.url).toString();

});

parcelRegister("4ux8O", function(module, exports) {
module.exports = new URL("pig.2ba131ea.svg", import.meta.url).toString();

});

parcelRegister("44Sb4", function(module, exports) {
module.exports = new URL("pineapple.61ebb967.svg", import.meta.url).toString();

});

parcelRegister("dQMZo", function(module, exports) {
module.exports = new URL("poodle.b40487d6.svg", import.meta.url).toString();

});

parcelRegister("zYoHs", function(module, exports) {
module.exports = new URL("rabbit.b4ce71c1.svg", import.meta.url).toString();

});

parcelRegister("04PGh", function(module, exports) {
module.exports = new URL("raccoon.16b4372e.svg", import.meta.url).toString();

});

parcelRegister("ddSO1", function(module, exports) {
module.exports = new URL("rhino.6dcdebb2.svg", import.meta.url).toString();

});

parcelRegister("ivVMv", function(module, exports) {
module.exports = new URL("robot.fdf311ba.svg", import.meta.url).toString();

});

parcelRegister("eJnd2", function(module, exports) {
module.exports = new URL("rose.22a6e8e6.svg", import.meta.url).toString();

});

parcelRegister("98ut7", function(module, exports) {
module.exports = new URL("seal.de226e3b.svg", import.meta.url).toString();

});

parcelRegister("9q1Vk", function(module, exports) {
module.exports = new URL("seedling.562f3bc0.svg", import.meta.url).toString();

});

parcelRegister("eMHgQ", function(module, exports) {
module.exports = new URL("shark.af44e0c5.svg", import.meta.url).toString();

});

parcelRegister("3LKHJ", function(module, exports) {
module.exports = new URL("shrimp.116d9eea.svg", import.meta.url).toString();

});

parcelRegister("3ZCOi", function(module, exports) {
module.exports = new URL("skunk.a5578a4f.svg", import.meta.url).toString();

});

parcelRegister("5xoX8", function(module, exports) {
module.exports = new URL("sloth.f3e9da22.svg", import.meta.url).toString();

});

parcelRegister("5qhol", function(module, exports) {
module.exports = new URL("snail.06380b65.svg", import.meta.url).toString();

});

parcelRegister("dGRYO", function(module, exports) {
module.exports = new URL("snake.3ead898b.svg", import.meta.url).toString();

});

parcelRegister("6dhVt", function(module, exports) {
module.exports = new URL("snowman.cdcd9574.svg", import.meta.url).toString();

});

parcelRegister("ighEF", function(module, exports) {
module.exports = new URL("squid.0638299b.svg", import.meta.url).toString();

});

parcelRegister("jiyfa", function(module, exports) {
module.exports = new URL("squirrel.e3a31ee3.svg", import.meta.url).toString();

});

parcelRegister("aRWto", function(module, exports) {
module.exports = new URL("strawberry.4111dfb6.svg", import.meta.url).toString();

});

parcelRegister("3VNps", function(module, exports) {
module.exports = new URL("sunflower.ff291a55.svg", import.meta.url).toString();

});

parcelRegister("62BuW", function(module, exports) {
module.exports = new URL("tiger.2ba2da26.svg", import.meta.url).toString();

});

parcelRegister("54a3y", function(module, exports) {
module.exports = new URL("tomato.e755033f.svg", import.meta.url).toString();

});

parcelRegister("cjnzF", function(module, exports) {
module.exports = new URL("tree.e62f2602.svg", import.meta.url).toString();

});

parcelRegister("faukZ", function(module, exports) {
module.exports = new URL("t-rex.d85831fb.svg", import.meta.url).toString();

});

parcelRegister("Ox4am", function(module, exports) {
module.exports = new URL("tropical-fish.797d455e.svg", import.meta.url).toString();

});

parcelRegister("hembw", function(module, exports) {
module.exports = new URL("turkey.a79defab.svg", import.meta.url).toString();

});

parcelRegister("5gEBh", function(module, exports) {
module.exports = new URL("turtle.acbe0058.svg", import.meta.url).toString();

});

parcelRegister("76eQq", function(module, exports) {
module.exports = new URL("watermelon.199e013c.svg", import.meta.url).toString();

});

parcelRegister("68Yx0", function(module, exports) {
module.exports = new URL("whale.cc048b8e.svg", import.meta.url).toString();

});

parcelRegister("l08I5", function(module, exports) {
module.exports = new URL("wolf.a39956da.svg", import.meta.url).toString();

});

parcelRegister("fDtVg", function(module, exports) {

var $1e2E5 = parcelRequire("1e2E5");

var $fI8ba = parcelRequire("fI8ba");


var $hTKp4 = parcelRequire("hTKp4");


var $eUBDm = parcelRequire("eUBDm");


var $hFOxw = parcelRequire("hFOxw");

const $9e6967f04f453315$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $9e6967f04f453315$var$intlCacheMap = new Map();
const $9e6967f04f453315$export$51771ec7613ad564 = async ()=>{
    const key = (0, $hTKp4.getDocument)()?.documentElement?.lang || 'en-US';
    if (!$9e6967f04f453315$var$intlCacheMap.has(key)) {
        const messages = await $9e6967f04f453315$var$fetchMessages(key);
        const cache = (0, $fI8ba.createIntlCache)();
        const intl = (0, $1e2E5.createIntl)({
            locale: key,
            messages: messages
        }, cache);
        $9e6967f04f453315$var$intlCacheMap.set(key, intl);
    }
    return $9e6967f04f453315$var$intlCacheMap.get(key);
};
const $9e6967f04f453315$var$fetchMessages = async (locale)=>{
    try {
        const targetLocale = ($9e6967f04f453315$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in (0, $eUBDm.locales)) {
            const messages = await (0, $eUBDm.locales)[targetLocale]();
            return messages.default;
        }
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $eUBDm.locales)) {
            const messages = await (0, $eUBDm.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    /**
   * English bundled by default as this is the majority of users
   */ return 0, $hFOxw.default;
};
module.exports["getIntl"] = $9e6967f04f453315$export$51771ec7613ad564;

});

parcelRegister("eUBDm", function(module, exports) {




























const $6e63713db070a09c$export$df1c34db1371eeed = {
    en: ()=>Promise.resolve((parcelRequire("hFOxw"))),
    cs: ()=>(parcelRequire("kc8TR")),
    da: ()=>(parcelRequire("l3Kdd")),
    de: ()=>(parcelRequire("69yb2")),
    en_GB: ()=>(parcelRequire("cSOaW")),
    en_ZZ: ()=>(parcelRequire("ctTgM")),
    es: ()=>(parcelRequire("7UFmH")),
    fi: ()=>(parcelRequire("9H5BD")),
    fr: ()=>(parcelRequire("gXf6j")),
    hr: ()=>(parcelRequire("3qf4b")),
    hu: ()=>(parcelRequire("d7gDR")),
    it: ()=>(parcelRequire("l2XrF")),
    ja: ()=>(parcelRequire("VVLwh")),
    ko: ()=>(parcelRequire("8mka3")),
    nb: ()=>(parcelRequire("16UCW")),
    nl: ()=>(parcelRequire("6xRKn")),
    pl: ()=>(parcelRequire("1tICX")),
    pt_BR: ()=>(parcelRequire("1nGwo")),
    ru: ()=>(parcelRequire("aVCyQ")),
    sr_RS: ()=>(parcelRequire("gJHrP")),
    sr_YR: ()=>(parcelRequire("lmyN0")),
    sv: ()=>(parcelRequire("fgOYH")),
    th: ()=>(parcelRequire("iASA2")),
    tr: ()=>(parcelRequire("gK9Le")),
    uk: ()=>(parcelRequire("5TJ1f")),
    vi: ()=>(parcelRequire("aaIRG")),
    zh: ()=>(parcelRequire("9nWlJ")),
    zh_TW: ()=>(parcelRequire("4oaks"))
};
module.exports["locales"] = $6e63713db070a09c$export$df1c34db1371eeed;

});

parcelRegister("kc8TR", function(module, exports) {

let $eb3bd4f74933f558$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb3bd4f74933f558$var$load("jMBLi").then(()=>parcelRequire('7ZLoJ'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("l3Kdd", function(module, exports) {

let $f54db99165770b8b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f54db99165770b8b$var$load("dKSPa").then(()=>parcelRequire('aEN3l'));

});

parcelRegister("69yb2", function(module, exports) {

let $0127f821ddfc863b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0127f821ddfc863b$var$load("aNGGp").then(()=>parcelRequire('33xoI'));

});

parcelRegister("cSOaW", function(module, exports) {

let $961172f85f6e3edb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $961172f85f6e3edb$var$load("16eqk").then(()=>parcelRequire('kWJx6'));

});

parcelRegister("ctTgM", function(module, exports) {

let $916310dbaec8ddd8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $916310dbaec8ddd8$var$load("smHwh").then(()=>parcelRequire('dbZYo'));

});

parcelRegister("7UFmH", function(module, exports) {

let $5c2dd99cb70ac8a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5c2dd99cb70ac8a2$var$load("lLAhl").then(()=>parcelRequire('9KFoy'));

});

parcelRegister("9H5BD", function(module, exports) {

let $70ec7a6fe087c63a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $70ec7a6fe087c63a$var$load("7lUpZ").then(()=>parcelRequire('4qdbO'));

});

parcelRegister("gXf6j", function(module, exports) {

let $c57ddebbf836b105$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c57ddebbf836b105$var$load("iFuRL").then(()=>parcelRequire('bIVe0'));

});

parcelRegister("3qf4b", function(module, exports) {

let $27df7cab7356feaf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $27df7cab7356feaf$var$load("bwpap").then(()=>parcelRequire('8NtSc'));

});

parcelRegister("d7gDR", function(module, exports) {

let $98c8d68f3df49e25$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $98c8d68f3df49e25$var$load("2qkmI").then(()=>parcelRequire('cGCVy'));

});

parcelRegister("l2XrF", function(module, exports) {

let $f527e57b693e6f21$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f527e57b693e6f21$var$load("kxYID").then(()=>parcelRequire('9bmhY'));

});

parcelRegister("VVLwh", function(module, exports) {

let $0ae221fff906b001$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ae221fff906b001$var$load("iHsNL").then(()=>parcelRequire('51o1K'));

});

parcelRegister("8mka3", function(module, exports) {

let $6160045ed2e1ab4f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6160045ed2e1ab4f$var$load("jGOT0").then(()=>parcelRequire('gLajM'));

});

parcelRegister("16UCW", function(module, exports) {

let $0cf246f0069fd885$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0cf246f0069fd885$var$load("3s5dS").then(()=>parcelRequire('2zKQ5'));

});

parcelRegister("6xRKn", function(module, exports) {

let $4c3f843445da2586$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c3f843445da2586$var$load("ffRdF").then(()=>parcelRequire('1nf4f'));

});

parcelRegister("1tICX", function(module, exports) {

let $113b1df702e7a97e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $113b1df702e7a97e$var$load("bS9i1").then(()=>parcelRequire('8l63g'));

});

parcelRegister("1nGwo", function(module, exports) {

let $1018ec47e040097d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1018ec47e040097d$var$load("3ydLu").then(()=>parcelRequire('asVO6'));

});

parcelRegister("aVCyQ", function(module, exports) {

let $7f4d23afc1ab1ef8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f4d23afc1ab1ef8$var$load("lqmbR").then(()=>parcelRequire('FrAje'));

});

parcelRegister("gJHrP", function(module, exports) {

let $c2f28d20061ad1be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c2f28d20061ad1be$var$load("3px1j").then(()=>parcelRequire('54f3C'));

});

parcelRegister("lmyN0", function(module, exports) {

let $f8d6a37afb93b948$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f8d6a37afb93b948$var$load("1NiRW").then(()=>parcelRequire('3pGwL'));

});

parcelRegister("fgOYH", function(module, exports) {

let $b1dfe4ceecde867c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b1dfe4ceecde867c$var$load("auBTD").then(()=>parcelRequire('5D8Rs'));

});

parcelRegister("iASA2", function(module, exports) {

let $d895ed4bca06a46b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d895ed4bca06a46b$var$load("fxn2i").then(()=>parcelRequire('aWxTt'));

});

parcelRegister("gK9Le", function(module, exports) {

let $c30883821cb64545$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c30883821cb64545$var$load("adwGb").then(()=>parcelRequire('34LZI'));

});

parcelRegister("5TJ1f", function(module, exports) {

let $44b502b0c10ff069$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44b502b0c10ff069$var$load("guUGa").then(()=>parcelRequire('2u29z'));

});

parcelRegister("aaIRG", function(module, exports) {

let $767da3c31aa6ce24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $767da3c31aa6ce24$var$load("9bAgX").then(()=>parcelRequire('clDBP'));

});

parcelRegister("9nWlJ", function(module, exports) {

let $01c369634d8d2eb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $01c369634d8d2eb9$var$load("HLzfe").then(()=>parcelRequire('9dypO'));

});

parcelRegister("4oaks", function(module, exports) {

let $33216a6e72302c57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33216a6e72302c57$var$load("in5qk").then(()=>parcelRequire('2iJQj'));

});

parcelRegister("hFOxw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1afed9367fc4c445$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $1afed9367fc4c445$export$2e2bcd8739ae039 = {
    'platform.anonymous-asset-name.alligator': 'Anonymous Alligator',
    'platform.anonymous-asset-name.alpaca': 'Anonymous Alpaca',
    'platform.anonymous-asset-name.ape': 'Anonymous Ape',
    'platform.anonymous-asset-name.apple': 'Anonymous Apple',
    'platform.anonymous-asset-name.avocado': 'Anonymous Avocado',
    'platform.anonymous-asset-name.baboon': 'Anonymous Baboon',
    'platform.anonymous-asset-name.badger': 'Anonymous Badger',
    'platform.anonymous-asset-name.bat': 'Anonymous Bat',
    'platform.anonymous-asset-name.bear': 'Anonymous Bear',
    'platform.anonymous-asset-name.beaver': 'Anonymous Beaver',
    'platform.anonymous-asset-name.bee': 'Anonymous Bee',
    'platform.anonymous-asset-name.bird': 'Anonymous Bird',
    'platform.anonymous-asset-name.bison': 'Anonymous Bison',
    'platform.anonymous-asset-name.blobfish': 'Anonymous Blobfish',
    'platform.anonymous-asset-name.blossom': 'Anonymous Blossom',
    'platform.anonymous-asset-name.blowfish': 'Anonymous Blowfish',
    'platform.anonymous-asset-name.blueberries': 'Anonymous Blueberries',
    'platform.anonymous-asset-name.boar': 'Anonymous Boar',
    'platform.anonymous-asset-name.broccoli': 'Anonymous Broccoli',
    'platform.anonymous-asset-name.buffalo': 'Anonymous Buffalo',
    'platform.anonymous-asset-name.bug': 'Anonymous Bug',
    'platform.anonymous-asset-name.bull': 'Anonymous Bull',
    'platform.anonymous-asset-name.bunny': 'Anonymous Bunny',
    'platform.anonymous-asset-name.butterfly': 'Anonymous Butterfly',
    'platform.anonymous-asset-name.cactus': 'Anonymous Cactus',
    'platform.anonymous-asset-name.camel': 'Anonymous Camel',
    'platform.anonymous-asset-name.candy': 'Anonymous Candy',
    'platform.anonymous-asset-name.cantaloupe': 'Anonymous Cantaloupe',
    'platform.anonymous-asset-name.capsicum': 'Anonymous Capsicum',
    'platform.anonymous-asset-name.carrot': 'Anonymous Carrot',
    'platform.anonymous-asset-name.cat': 'Anonymous Cat',
    'platform.anonymous-asset-name.caterpiller': 'Anonymous Caterpiller',
    'platform.anonymous-asset-name.chameleon': 'Anonymous Chameleon',
    'platform.anonymous-asset-name.cherry': 'Anonymous Cherry',
    'platform.anonymous-asset-name.chili': 'Anonymous Chili',
    'platform.anonymous-asset-name.chimp': 'Anonymous Chimp',
    'platform.anonymous-asset-name.chimpanzee': 'Anonymous Chimpanzee',
    'platform.anonymous-asset-name.clover': 'Anonymous Clover',
    'platform.anonymous-asset-name.clownfish': 'Anonymous Clownfish',
    'platform.anonymous-asset-name.cobra': 'Anonymous Cobra',
    'platform.anonymous-asset-name.coconut': 'Anonymous Coconut',
    'platform.anonymous-asset-name.cod': 'Anonymous Cod',
    'platform.anonymous-asset-name.cookie': 'Anonymous Cookie',
    'platform.anonymous-asset-name.corn': 'Anonymous Corn',
    'platform.anonymous-asset-name.cow': 'Anonymous Cow',
    'platform.anonymous-asset-name.crab': 'Anonymous Crab',
    'platform.anonymous-asset-name.crocodile': 'Anonymous Crocodile',
    'platform.anonymous-asset-name.deer': 'Anonymous Deer',
    'platform.anonymous-asset-name.dinosaur': 'Anonymous Dinosaur',
    'platform.anonymous-asset-name.dodo': 'Anonymous Dodo',
    'platform.anonymous-asset-name.dog': 'Anonymous Dog',
    'platform.anonymous-asset-name.dolphin': 'Anonymous Dolphin',
    'platform.anonymous-asset-name.donut': 'Anonymous Donut',
    'platform.anonymous-asset-name.dragon': 'Anonymous Dragon',
    'platform.anonymous-asset-name.duck': 'Anonymous Duck',
    'platform.anonymous-asset-name.elephant': 'Anonymous Elephant',
    'platform.anonymous-asset-name.elk': 'Anonymous Elk',
    'platform.anonymous-asset-name.fish': 'Anonymous Fish',
    'platform.anonymous-asset-name.flamingo': 'Anonymous Flamingo',
    'platform.anonymous-asset-name.fox': 'Anonymous Fox',
    'platform.anonymous-asset-name.frog': 'Anonymous Frog',
    'platform.anonymous-asset-name.gecko': 'Anonymous Gecko',
    'platform.anonymous-asset-name.giraffe': 'Anonymous Giraffe',
    'platform.anonymous-asset-name.gorilla': 'Anonymous Gorilla',
    'platform.anonymous-asset-name.grape': 'Anonymous Grape',
    'platform.anonymous-asset-name.hammerhead': 'Anonymous Hammerhead',
    'platform.anonymous-asset-name.hedgehog': 'Anonymous Hedgehog',
    'platform.anonymous-asset-name.hippo': 'Anonymous Hippo',
    'platform.anonymous-asset-name.kangaroo': 'Anonymous Kangaroo',
    'platform.anonymous-asset-name.kitten': 'Anonymous Kitten',
    'platform.anonymous-asset-name.kiwi': 'Anonymous Kiwi',
    'platform.anonymous-asset-name.koala': 'Anonymous Koala',
    'platform.anonymous-asset-name.lemon': 'Anonymous Lemon',
    'platform.anonymous-asset-name.leopard': 'Anonymous Leopard',
    'platform.anonymous-asset-name.lettuce': 'Anonymous Lettuce',
    'platform.anonymous-asset-name.lion': 'Anonymous Lion',
    'platform.anonymous-asset-name.lizard': 'Anonymous Lizard',
    'platform.anonymous-asset-name.llama': 'Anonymous Llama',
    'platform.anonymous-asset-name.lobster': 'Anonymous Lobster',
    'platform.anonymous-asset-name.macaque': 'Anonymous Macaque',
    'platform.anonymous-asset-name.mango': 'Anonymous Mango',
    'platform.anonymous-asset-name.melon': 'Anonymous Melon',
    'platform.anonymous-asset-name.millipede': 'Anonymous Millipede',
    'platform.anonymous-asset-name.monkey': 'Anonymous Monkey',
    'platform.anonymous-asset-name.mouse': 'Anonymous Mouse',
    'platform.anonymous-asset-name.octopus': 'Anonymous Octopus',
    'platform.anonymous-asset-name.olive': 'Anonymous Olive',
    'platform.anonymous-asset-name.orange': 'Anonymous Orange',
    'platform.anonymous-asset-name.orangutan': 'Anonymous Orangutan',
    'platform.anonymous-asset-name.otter': 'Anonymous Otter',
    'platform.anonymous-asset-name.owl': 'Anonymous Owl',
    'platform.anonymous-asset-name.ox': 'Anonymous Ox',
    'platform.anonymous-asset-name.oyster': 'Anonymous Oyster',
    'platform.anonymous-asset-name.panda': 'Anonymous Panda',
    'platform.anonymous-asset-name.parrot': 'Anonymous Parrot',
    'platform.anonymous-asset-name.peacock': 'Anonymous Peacock',
    'platform.anonymous-asset-name.pear': 'Anonymous Pear',
    'platform.anonymous-asset-name.penguin': 'Anonymous Penguin',
    'platform.anonymous-asset-name.pig': 'Anonymous Pig',
    'platform.anonymous-asset-name.pineapple': 'Anonymous Pineapple',
    'platform.anonymous-asset-name.poodle': 'Anonymous Poodle',
    'platform.anonymous-asset-name.puppy': 'Anonymous Puppy',
    'platform.anonymous-asset-name.python': 'Anonymous Python',
    'platform.anonymous-asset-name.rabbit': 'Anonymous Rabbit',
    'platform.anonymous-asset-name.raccoon': 'Anonymous Raccoon',
    'platform.anonymous-asset-name.rat': 'Anonymous Rat',
    'platform.anonymous-asset-name.rhino': 'Anonymous Rhino',
    'platform.anonymous-asset-name.robot': 'Anonymous Robot',
    'platform.anonymous-asset-name.rose': 'Anonymous Rose',
    'platform.anonymous-asset-name.seal': 'Anonymous Seal',
    'platform.anonymous-asset-name.seedling': 'Anonymous Seedling',
    'platform.anonymous-asset-name.shark': 'Anonymous Shark',
    'platform.anonymous-asset-name.shrimp': 'Anonymous Shrimp',
    'platform.anonymous-asset-name.skunk': 'Anonymous Skunk',
    'platform.anonymous-asset-name.sloth': 'Anonymous Sloth',
    'platform.anonymous-asset-name.snail': 'Anonymous Snail',
    'platform.anonymous-asset-name.snake': 'Anonymous Snake',
    'platform.anonymous-asset-name.snowman': 'Anonymous Snowman',
    'platform.anonymous-asset-name.squid': 'Anonymous Squid',
    'platform.anonymous-asset-name.squirrel': 'Anonymous Squirrel',
    'platform.anonymous-asset-name.strawberry': 'Anonymous Strawberry',
    'platform.anonymous-asset-name.sunfish': 'Anonymous Sunfish',
    'platform.anonymous-asset-name.sunflower': 'Anonymous Sunflower',
    'platform.anonymous-asset-name.tiger': 'Anonymous Tiger',
    'platform.anonymous-asset-name.tomato': 'Anonymous Tomato',
    'platform.anonymous-asset-name.tortoise': 'Anonymous Tortoise',
    'platform.anonymous-asset-name.tree': 'Anonymous Tree',
    'platform.anonymous-asset-name.trex': 'Anonymous T-rex',
    'platform.anonymous-asset-name.trout': 'Anonymous Trout',
    'platform.anonymous-asset-name.turkey': 'Anonymous Turkey',
    'platform.anonymous-asset-name.turtle': 'Anonymous Turtle',
    'platform.anonymous-asset-name.wasp': 'Anonymous Wasp',
    'platform.anonymous-asset-name.watermelon': 'Anonymous Watermelon',
    'platform.anonymous-asset-name.whale': 'Anonymous Whale',
    'platform.anonymous-asset-name.wolf': 'Anonymous Wolf'
};

});

parcelRegister("99F08", function(module, exports) {
const $a1227471ca9b2621$export$435a991cb82816ff = (retryCount, initialDelay = 1000, maxDelay = 30000, factor = 2)=>{
    // Calculate exponential backoff
    const delay = Math.min(initialDelay * Math.pow(factor, retryCount), maxDelay);
    // Add random jitter (between 0 and current delay value)
    return Math.floor(Math.random() * delay);
};
const $a1227471ca9b2621$export$cffaac380b94df26 = async ({ url: url, options: options, shouldRetryOnApiError: shouldRetryOnApiError, retries: retries = 3, baseDelay: baseDelay = 300, maxDelay: maxDelay = 10000 })=>{
    try {
        const response = await fetch(url, options);
        if (response.ok) return {
            success: true,
            result: response
        };
        if (shouldRetryOnApiError) throw new Error('Failed request with an error');
        const errorBody = await response.json();
        return {
            success: false,
            error: new Error(errorBody)
        };
    } catch (error) {
        if (retries > 0) {
            const retryDelay = $a1227471ca9b2621$export$435a991cb82816ff(retries, baseDelay, maxDelay);
            await new Promise((resolve)=>setTimeout(resolve, retryDelay));
            return $a1227471ca9b2621$export$cffaac380b94df26({
                url: url,
                options: options,
                shouldRetryOnApiError: shouldRetryOnApiError,
                retries: retries - 1,
                baseDelay: baseDelay,
                maxDelay: maxDelay
            });
        }
        const newError = error instanceof Error ? error : new Error('An unknown error occurred');
        return {
            success: false,
            error: newError
        };
    }
};
module.exports["fetchWithRetry"] = $a1227471ca9b2621$export$cffaac380b94df26;

});

parcelRegister("5Za2S", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");


var $04e9M = parcelRequire("04e9M");


var $9137z = parcelRequire("9137z");


var $j8hiR = parcelRequire("j8hiR");


var $747ya = parcelRequire("747ya");


var $iby4Y = parcelRequire("iby4Y");

const $8ae4f0f25e352c24$var$STATUS_NOT_FOUND = 404;
const $8ae4f0f25e352c24$var$performRecovery = async (contentId)=>{
    return (0, $iby4Y.experimentalResetCollabServiceMutate)({
        variables: {
            behind: 'COLLAB',
            contentId: contentId
        }
    });
};
const $8ae4f0f25e352c24$var$fireDraftFailureEvent = (error, recoverySucceeded, recoveryError)=>{
    (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            source: 'NativeCollabProvider',
            action: 'getDraft',
            actionSubject: 'failure',
            attributes: {
                error: error,
                recoverySucceeded: recoverySucceeded,
                recoveryError: recoveryError
            }
        });
    });
};
const $8ae4f0f25e352c24$var$fireDraftFetchEvent = (state)=>{
    (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            source: 'NativeCollabProvider',
            action: 'sentRequest',
            actionSubject: 'NcsDraftEndpoint',
            attributes: {
                state: state
            }
        });
    });
};
const $8ae4f0f25e352c24$var$fetchDraftPromiseWithMetrics = (fetchDraftPromise)=>{
    return fetchDraftPromise.then((response)=>{
        if (response.error) $8ae4f0f25e352c24$var$fireDraftFetchEvent('failure');
        else $8ae4f0f25e352c24$var$fireDraftFetchEvent('success');
        return response;
    }).catch((error)=>{
        $8ae4f0f25e352c24$var$fireDraftFetchEvent('failure');
        throw error;
    });
};
const $8ae4f0f25e352c24$export$1a473231c51c1d5b = (contentId, draftShareId)=>$8ae4f0f25e352c24$export$9a3b244f90691dba(contentId, (0, $747ya.fetchDraft)(contentId, draftShareId));
const $8ae4f0f25e352c24$export$9a3b244f90691dba = (contentId, fetchDraftPromise)=>{
    (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT);
    return $8ae4f0f25e352c24$var$fetchDraftPromiseWithMetrics(fetchDraftPromise).then(async ({ draft: draft })=>{
        (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT);
        if (draft) {
            const version = draft?.version;
            if (!version) {
                (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                    client.sendOperationalEvent({
                        source: 'NativeCollabProvider',
                        action: 'getDraft',
                        actionSubject: 'version is 0',
                        attributes: {
                            version: version
                        }
                    });
                });
                return null;
            }
            return draft;
        }
        return null;
    }).catch((error)=>{
        (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT);
        if (error instanceof (0, $hBkCm.BadStatusError) && error?.response?.status === $8ae4f0f25e352c24$var$STATUS_NOT_FOUND) return $8ae4f0f25e352c24$var$performRecovery(contentId).then((_recoveryResponse)=>{
            $8ae4f0f25e352c24$var$fireDraftFailureEvent(error, true);
            return null;
        }).catch((recoveryError)=>{
            $8ae4f0f25e352c24$var$fireDraftFailureEvent(error, false, recoveryError);
            return null;
        });
        $8ae4f0f25e352c24$var$fireDraftFailureEvent(error, null);
        return null;
    });
};
module.exports["getDraft"] = $8ae4f0f25e352c24$export$1a473231c51c1d5b;
module.exports["getDraftFromPromise"] = $8ae4f0f25e352c24$export$9a3b244f90691dba;

});

parcelRegister("iby4Y", function(module, exports) {

var $4GGNn = parcelRequire("4GGNn");


var $aBfpe = parcelRequire("aBfpe");


var $hBkCm = parcelRequire("hBkCm");

var $9kGfD = parcelRequire("9kGfD");


var $b4EKK = parcelRequire("b4EKK");

const $41df7c78720ad922$export$6d7c9d246960833d = ({ variables: variables })=>{
    return (0, $4GGNn.experimentalMutate)({
        url: `/wiki/rest/collab/1.0/content/${variables.contentId}/reset?behind=${variables.behind || 'COLLAB'}`,
        method: 'PUT',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        variables: variables,
        parseResponseOnSuccess: (response)=>({
                traceId: (0, $9kGfD.getTraceIdFromResponse)(response) ?? ''
            }),
        parseResult: (response)=>({
                experimentalResetCollabService: {
                    traceId: response.traceId
                }
            })
    }).catch(async (error)=>{
        const response = error instanceof (0, $hBkCm.BadStatusError) ? error.response : undefined;
        if (response) throw (0, $b4EKK.getErrorWithResponse)(error, response);
        throw error;
    });
};
module.exports["experimentalResetCollabServiceMutate"] = $41df7c78720ad922$export$6d7c9d246960833d;

});

parcelRegister("j7xMJ", function(module, exports) {

var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");

const $8264c3c0961f9494$export$5ca6730fa0e353e8 = ()=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const client = isGuest || !isLoggedIn || !isLicensed ? 'agg' : 'ccgraphql';
    return {
        client: client
    };
};
module.exports["useFetchUsersClient"] = $8264c3c0961f9494$export$5ca6730fa0e353e8;

});


//# sourceMappingURL=NativeCollabComponent.074e60fa.js.map
